import {
  FINANCIAL_REPORTS_SUCCESS,
  FINANCIAL_REPORTS_COMPLETE_SUCCESS,
  FINANCIAL_SUMMARY_REPORTS_COMPLETE_SUCCESS,
  FINANCIAL_REPORTS_FAILED,
  CALCULATION_REPORTS_SUCCESS,
  SHOW_MESSAGE,
  TARGET_REPORTS_SUCCESS,
  RATIO_KEY_FIGURES_REPORTS_SUCCESS,
  ADD_MATERIAL_DESIGN_SUCCESS,
  EXECUTE_FILTER_VALUES_SUCCESS,
  INCENTIVE_RATIO_TREND_REPORTS_SUCCESS,
  TOP_N_ATTRIBUTES_REPORTS_SUCCESS,
  DUPLICATE_PAYMENT_REPORTS_SUCCESS,
  ANAMOLY_REPORTS_SUCCESS,
  APPROVAL_POSTING_HISTORY_REPORTS_SUCCESS,
  CONTRACT_HISTORY_APPROVAL_SUCCESS,
  DOCUMENT_HISTORY_APPROVAL_SUCCESS,
  NTE_LIFE_TIME_SUCCESS,
  CONTRACT_SEARCH_BY_CUSTOMER,
  EXCEPTION_SEARCH_BY_CUSTOMER,
  SAVE_SIMULATION_STATE,
  CLEAR_SIMULATION_STATE,
  CLEAR_EXCEPTION_SEARCH_BY_CUSTOMER,
  SIMULATE_REBATE_ESTIMATOR,
  CLEAR_SIMULATE_REBATE_ESTIMATOR,
  SAVE_SIMULATE_REBATE_ESTIMATOR_STATE,
  CLEAR_SIMULATE_REBATE_ESTIMATOR_STATE,
  FORMULA_EXCEPTION,
  CLEAR_FORMULA_EXCEPTION,
  CALCULATION_FORMULA_VALUES_REPORTS_SUCCESS,
  GET_DATAGRID_METADATA_SUCCESS,
  CONTRACT_CHANGE_REPORTS_SUCCESS,
  FINANCIAL_SUMMARY_SUCCESS,
  CALCULATION_REPORTS_COMPLETE_SUCCESS,
  TARGET_REPORTS_COMPLETE_SUCCESS,
  CONTRACT_CHANGE_REPORTS_COMPLETE_SUCCESS,
  FINANCIAL_SUMMARY_COMPLETE_SUCCESS,
  CALCULATION_REPORTS_FAILED,
  GET_REPORT_LIST_DATA_SUCCESS,
  FINANCIAL_SUMMARY_REPORTS_COMPLETE_FAILED,
  TARGET_REPORTS_FAILED,
  CONTRACT_CHANGE_REPORTS_FAILED,
  FINANCIAL_SUMMARY_FAILED,
  INVOICE_REPORTS_SUCCESS,
  INVOICE_REPORTS_COMPLETE_SUCCESS,
  INVOICE_REPORTS_FAILED,
  CONTRACT_REPORTS_SUCCESS,
  CONTRACT_REPORTS_COMPLETE_SUCCESS,
  CONTRACT_REPORTS_FAILED,
  FETCH_START,
  FETCH_END,
  EXCEPTION_FETCH_START,
  EXCEPTION_FETCH_END,
  CONTRACT_REPORTS_OVERLAP_SUCCESS,
  DYNAMIC_QUERY_FIELDS_SUCCESS,
  DYNAMIC_QUERY_FIELDS_SUCCESS_NEW,
  QUERY_LIST_SUCCESS,
  QUERY_LIST_CLEAR,
  QUERY_RESULTS_FINAL_SUCCESS,
  DYNAMIC_FILTER_API_SUCCESS,
  DYNAMIC_QUERY_DETAILS_SUCCESS,
  CLAIMS_FORMAT_FIELDS_SUCCESS,
  INCOMING_CLAIM_DETAILS_SUCCESS,
  QUERY_LIST_ADMIN_SUCCESS,
  QUERY_TYPES_SUCCESS,
  LOAD_TARGET_DATA,
  COLL_PORTAL_CUST_SUPP,
  OUTGOING_CLAIMS_FORMAT_FIELDS_SUCCESS,
  OUTGOING_CLAIM_DETAILS_SUCCESS,
  GET_ALL_ORG_USERS,
  TABLE_DETERMINATION_SUCCESS,
  PREDEFINED_QUERY_RESULTS_FINAL_SUCCESS,
  ALERT_MANAGEMENT_REPORT_SUCCESS,
  PREDEFINED_QUERY_DETAILS_SUCCESS,
  CUSTOM_VIEW,
  GET_FILTER_VALUES_SUCCESS,
  DYNAMIC_QUERY_FILTER,
  DYNAMIC_QUERY_FILTER_BY_ID,
  RECONCILE_INTEGRATION_SUCCESS,
  FILTER_VALUES_BY_ID,
  GET_COLLABORATION_BY_ID_SUCCESS,
  ADD_MATERIAL_DESIGN,
  VIEW_MATERIAL_DESIGN_SUCCESS,
  DELETE_MATERIAL_MASTER_SUCCESS,
  DELETE_MATERIAL_MASTER_FAIL,
  DELETE_MATERIAL_DESIGN_START,
  DELETE_MATERIAL_DESIGN_SUCCESS,
  DELETE_MATERIAL_DESIGN_FAIL,
  DELETE_MATERIAL_DESIGN_END,
  OUTGOING_CLAIMS_REPORT_SUCCESS,
  DELETE_SUPPLIER_DESIGN_SUCCESS,
  DELETE_PRODUCT_MATERIAL_DESIGN_FAIL,
  DELETE_PRODUCT_MATERIAL_DESIGN_SUCCESS,
  DELETE_SUPPLIER_DESIGN_FAIL,
  DELETE_CUSTOMER_DESIGN_SUCCESS,
  DELETE_EMPLOYEE_DESIGN_SUCCESS,
  DELETE_EMPLOYEE_DESIGN_FAIL,
  DELETE_CUSTOMER_DESIGN_FAIL,
  GET_EMPLOYEE_BY_PROFILE_SUCCESS,
  CLONE_SUPPLIER_MASTER_SUCCESS,
  CLONE_MATERIAL_MASTER_SUCCESS,
  CLONE_EMPLOYEE_MASTER_SUCCESS,
  COPY_SUPPLIER_PROFILE_SUCCESS,
  COPY_SUPPLIER_PROFILE_FAIL,
  SET_SUPPLIER_PROFILE_DEFAULT_SUCCESS,
  SET_CUSTOMER_PROFILE_DEFAULT_FAIL,
  SET_CUSTOMER_PROFILE_DEFAULT_SUCCESS,
  SET_EMPLOYEE_PROFILE_DEFAULT_FAIL,
  SET_EMPLOYEE_PROFILE_DEFAULT_SUCCESS,
  SET_MATERIAL_PROFILE_DEFAULT_SUCCESS,
  SET_MATERIAL_PROFILE_DEFAULT_FAIL,
  SET_SUPPLIER_PROFILE_DEFAULT_FAIL,
  MEMBERSHIP_TABLE_SUCCESS,
  BATCH_JOB_FILTERS,
  GET_CONTROL_CONFIG_SUCCESS,
  CONTROL_CONFIG_DATA_SUCCESS,
  SUPPLIER_REBATE_ACCRUAL_POSTING_RESULTS_SUCCESS, EXECUTE_REPORT_SUCCESS, CLEAR_EXECUTE_REPORT,
  POSTINGS_RESULTS_SUCCESS
} from './ActionTypes';
import axios from '../../../../axios.conf';
import { history } from '../../../../components/Helpers';
import { getRebateResultsPath } from '../../../../components/Helpers/rebateRoute';
import { toast } from 'react-toastify';
import { toast as globalToast } from '../../../../components/ToastManager';
import { ServerError } from '../../../../library/constants';
import secureLocalStorage from 'react-secure-storage';
import { handleExecutionLog } from '../../../../components/ExecutionLogHandler';
import { getMasterDataProfile } from '../../MasterData/MasterDataAction';

export const fetchStart = (actionType) => {
  return {
    type: actionType ? actionType : FETCH_START,
  };
};

export const fetchEnd = (actionType) => {
  return {
    type: actionType ? actionType : FETCH_END,
  };
};

export const financialReportsSuccess = (data) => {
  return {
    type: FINANCIAL_REPORTS_SUCCESS,
    data,
  };
};

export const financialReportsFailed = (data) => {
  return {
    type: FINANCIAL_REPORTS_FAILED,
    data,
  };
};

export const runFinancialSummaryReports = (pagination, limit, keyword) => {
  return (dispatch) => {
    runFinancialSummaryReportsAPI(pagination, limit, keyword)
      .then((response) => {
        dispatch(
          runFinancialSummaryReportsComplete(
            response.data.response.records?.length,
          ),
        );
        dispatch(fetchEnd());
        if (response.data.response.records?.length > 0) {
          dispatch(financialReportsSuccess(response.data.response));
          history.push('/financial-approvals-reports/results');
        }
      })
      .catch((error) => { });
  };
};
const runFinancialSummaryReportsAPI = (pagination, limit, keyword) => {
  let data = JSON.parse(localStorage.getItem('FinancialSummaryReportsData'));
  for (let propName in data) {
    if (
      data[propName] === '' ||
      data[propName] === null ||
      data[propName] === undefined ||
      data[propName].length === 0 ||
      data[propName] === '1970-01-01T00:00:00.000Z,1970-01-01T00:00:00.000Z' ||
      data[propName] === '1970-01-01T00:00:00.000Z' ||
      data[propName] === ','
    ) {
      delete data[propName];
    }
  }
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  let result;
  result = axios.get(
    'financial_postings/grouped?page=' + pagination + '&limit=' + limit,
    { params: data, headers: headers },
  );
  return result;
};

export const runFinancialReports = (pagination, limit, keyword) => {
  return (dispatch) => {
    dispatch(fetchStart());
    getFinancialReportsAPi(pagination, limit, keyword)
      .then((response) => {
        dispatch(
          runFinancialReportsComplete(response.data.response.records?.length),
        );
        dispatch(fetchEnd());
        if (response.data.response.records?.length > 0) {
          dispatch(financialReportsSuccess(response.data.response));
          history.push('/financial-postings-reports/financial-reports');
        }
      })
      .catch((error) => {
        dispatch(fetchEnd());
        dispatch(financialReportsFailed(error));
      });
  };
};

const getFinancialReportsAPi = (pagination, limit, keyword) => {
  let data = JSON.parse(sessionStorage.getItem('FinancialReportsData'));
  for (let propName in data) {
    if (
      data[propName] === '' ||
      data[propName] === null ||
      data[propName] === undefined ||
      data[propName].length === 0 ||
      data[propName] === '1970-01-01T00:00:00.000Z,1970-01-01T00:00:00.000Z' ||
      data[propName] === '1970-01-01T00:00:00.000Z' ||
      data[propName] === ','
    ) {
      delete data[propName];
    }
  }
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  let result;
  if (keyword === 'noFilter') {
    result = axios.get(
      'financial_postings?page=' + pagination + '&limit=' + limit,
      { headers: headers },
    );
  } else if (keyword) {
    result = axios.get(
      'financial_postings?page=' +
      pagination +
      '&limit=' +
      limit +
      '&keyword=' +
      keyword,
      { params: data, headers: headers },
    );
  } else {
    result = axios.get(
      'financial_postings?page=' + pagination + '&limit=' + limit,
      { params: data, headers: headers },
    );
  }
  return result;
};

export const generateFinancialReports = (pagination, limit, keyword) => {
  return (dispatch) => {
    dispatch(fetchStart());
    generateFinancialReportsApi(pagination, limit, keyword)
      .then((response) => {
        if (response.data.response.records?.length > 0) {
          let result = response.data.response.records.map(
            ({
              contract_number,
              incentive_rate,
              incentive_amount,
              incentive_basis,
            }) => ({
              contract_number,
              incentive_rate,
              incentive_amount,
              incentive_basis,
            }),
          );
          dispatch(generatePDF(result));
        }
      })
      .catch((error) => {
        dispatch(fetchEnd());
        dispatch(financialReportsFailed(error));
      });
  };
};

export const generatePDF = (data) => {
  return (dispatch) => {
    generatePDFApi(data).then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      let date = Date.now();
      link.setAttribute('download', date + '.pdf'); //or any other extension
      document.body.appendChild(link);
      link.click();
    });
  };
};

const generatePDFApi = (data) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  let result;
  result = axios.post('generate-pdf', data, {
    headers: headers,
    responseType: 'blob',
  });
  return result;
};

const generateFinancialReportsApi = (pagination, limit, keyword) => {
  let data = JSON.parse(sessionStorage.getItem('FinancialReportsData'));
  for (let propName in data) {
    if (
      data[propName] === '' ||
      data[propName] === null ||
      data[propName] === undefined ||
      data[propName].length === 0 ||
      data[propName] === '1970-01-01T00:00:00.000Z,1970-01-01T00:00:00.000Z' ||
      data[propName] === '1970-01-01T00:00:00.000Z' ||
      data[propName] === ','
    ) {
      delete data[propName];
    }
  }
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  let result;
  result = axios.get(
    'financial_postings?limit=0',
    { params: data, headers: headers },
  );
  return result;
};

export const financialReportsCompleteSuccess = (data) => {
  return {
    type: FINANCIAL_REPORTS_COMPLETE_SUCCESS,
    data,
  };
};

export const runFinancialReportsComplete = (totalRecords) => {
  return (dispatch) => {
    getFinancialReportsCompleteApi(totalRecords)
      .then((response) => {
        if (response.data.response.records?.length > 0) {
          dispatch(financialReportsCompleteSuccess(response.data.response));
        }
      })
      .catch((error) => { });
  };
};

const getFinancialReportsCompleteApi = (totalRecords) => {
  let data = JSON.parse(sessionStorage.getItem('FinancialReportsData'));
  for (let propName in data) {
    if (
      data[propName] === '' ||
      data[propName] === null ||
      data[propName] === undefined ||
      data[propName].length === 0 ||
      data[propName] === '1970-01-01T00:00:00.000Z,1970-01-01T00:00:00.000Z' ||
      data[propName] === '1970-01-01T00:00:00.000Z' ||
      data[propName] === ','
    ) {
      delete data[propName];
    }
  }
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  const result = axios.get(
    'financial_postings?limit=' + totalRecords,
    { params: data, headers: headers },
  );
  return result;
};

export const financialSummaryReportsCompleteSuccess = (data) => {
  return {
    type: FINANCIAL_SUMMARY_REPORTS_COMPLETE_SUCCESS,
    data,
  };
};
export const financialSummaryReportsCompleteFailed = (data) => {
  return {
    type: FINANCIAL_SUMMARY_REPORTS_COMPLETE_FAILED,
    data,
  };
};

export const runFinancialSummaryReportsComplete = (totalRecords) => {
  return (dispatch) => {
    getFinancialSummaryReportsCompleteApi(totalRecords)
      .then((response) => {
        if (response.data.response.records?.length > 0) {
          dispatch(
            financialSummaryReportsCompleteSuccess(response.data.response),
          );
        }
      })
      .catch((error) => { });
  };
};

const getFinancialSummaryReportsCompleteApi = (totalRecords) => {
  let data = JSON.parse(localStorage.getItem('FinancialSummaryReportsData'));
  for (let propName in data) {
    if (
      data[propName] === '' ||
      data[propName] === null ||
      data[propName] === undefined ||
      data[propName].length === 0 ||
      data[propName] === '1970-01-01T00:00:00.000Z,1970-01-01T00:00:00.000Z' ||
      data[propName] === '1970-01-01T00:00:00.000Z' ||
      data[propName] === ','
    ) {
      delete data[propName];
    }
  }
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  const result = axios.get(
    'financial_postings/grouped?limit=' + totalRecords,
    { params: data, headers: headers },
  );
  return result;
};

export const calculationReportsSuccess = (data) => {
  return {
    type: CALCULATION_REPORTS_SUCCESS,
    data,
  };
};

export const calculationReportsFailed = (data) => {
  return {
    type: CALCULATION_REPORTS_FAILED,
    data,
  };
};
// Get Report List
export const getReportList = (data) => {
  return (dispatch) => {
    dispatch(fetchStart());
    getReportListAPi(data)
      .then((response) => {
        dispatch(fetchEnd());
        dispatch(getReportListDataSuccess(response.data.response));
      })
      .catch((error) => {
        dispatch(fetchEnd());
      });
  };
};

const getReportListAPi = (data) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result = axios.post(
    'reports/by-category',
    data,
    { headers: headers },
  );
  return result;
};
export const getReportListDataSuccess = (data) => {
  return {
    type: GET_REPORT_LIST_DATA_SUCCESS,
    data,
  };
};

export const runCalculationReports = (pagination, limit, keyword) => {
  return (dispatch) => {
    dispatch(fetchStart());
    getCalculationReportsAPi(pagination, limit, keyword)
      .then((response) => {
        dispatch(fetchEnd());
        if (response.data.response.records?.length > 0) {
          dispatch(fetchEnd());
          dispatch(calculationReportsSuccess(response.data.response));
          history.push('/calculation-simulation-reports/calculation-reports');
          dispatch(
            runCalculationReportsComplete(
              response.data.response.records?.length,
            ),
          );
        }
      })
      .catch((error) => {
        dispatch(fetchEnd());
        dispatch(calculationReportsFailed(error));
      });
  };
};

const getCalculationReportsAPi = (pagination, limit, keyword) => {
  const data = JSON.parse(sessionStorage.getItem('CalculationReportsData'));
  for (let propName in data) {
    if (
      data[propName] === '' ||
      data[propName] === null ||
      data[propName] === undefined ||
      data[propName].length === 0 ||
      data[propName] === '1970-01-01T00:00:00.000Z,1970-01-01T00:00:00.000Z' ||
      data[propName] === '1970-01-01T00:00:00.000Z' ||
      data[propName] === ','
    ) {
      delete data[propName];
    }
  }
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  let result;
  if (keyword) {
    result = axios.get(
      'calculation_simulations?page=' +
      pagination +
      '&limit=' +
      limit +
      '&keyword=' +
      keyword,
      { params: data, headers: headers },
    );
  } else {
    result = axios.get(
      'calculation_simulations?page=' + pagination + '&limit=' + limit,
      { params: data, headers: headers },
    );
  }
  return result;
};

export const targetReportsFailed = (data) => {
  return {
    type: TARGET_REPORTS_FAILED,
    data,
  };
};
//DataGrid MetaData
export const getDataGridMetaData = (data) => {
  return (dispatch) => {
    dispatch(fetchStart());
    getDataGridMetaDataAPi(data)
      .then((response) => {
        dispatch(fetchEnd());
        dispatch(getDataGridMetaDataSuccess(response.data.response));
      })
      .catch((error) => {
        dispatch(fetchEnd());
      });
  };
};

const getDataGridMetaDataAPi = (data) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result = axios.post(
    'data-grid',
    data,
    { headers: headers },
  );
  return result;
};
export const getDataGridMetaDataSuccess = (data) => {
  return {
    type: GET_DATAGRID_METADATA_SUCCESS,
    data,
  };
};
// calculation formula values
export const runCalculationFormulaValuesReports = (data, UUID, exclusive, options = {}) => {
  const { skipRedirect = false, onSuccess = null } = options;
  return (dispatch) => {
    dispatch(fetchStart());
    getCalculationFormulaValuesReportsAPi(data, UUID, exclusive)
      .then((response) => {
        dispatch(fetchEnd());
        if (response.data.response.length > 0) {
          dispatch(fetchEnd());
          const resultRows = response.data.response;
          dispatch(
            calculationFormulaValuesReportsSuccess(resultRows),
          );
          if (typeof onSuccess === 'function') {
            onSuccess(resultRows);
          }
          if (!skipRedirect) {
            history.push('/calulate-formula-values-reports-results');
          }
        } else {
          globalToast.showWarning('No records found.');
        }
      })
      .catch((error) => {
        dispatch(fetchEnd());
      });
  };
};

const getCalculationFormulaValuesReportsAPi = (data, UUID, exclusive) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  if (UUID) {
    result = axios.post(
      'formula-calculation?app_type=Customer Rebate&data_source_type=Direct - Sales Data' +
      '&request_id=' +
      UUID +
      '&is_exclusive=' +
      exclusive,
      data,
      { headers: headers },
    );
  } else {
    const exclusiveParam = exclusive === true || exclusive === 'true';
    result = axios.post(
      'formula-calculation?app_type=Customer Rebate&data_source_type=Direct - Sales Data&is_exclusive=' +
      exclusiveParam,
      data,
      { headers: headers },
    );
  }
  return result;
};
export const calculationFormulaValuesReportsSuccess = (data) => {
  return {
    type: CALCULATION_FORMULA_VALUES_REPORTS_SUCCESS,
    data,
  };
};
// ratio key figures reports
export const runRatioKeyFiguresReports = (data, UUID) => {
  return (dispatch) => {
    dispatch(fetchStart());
    getRatioKeyFiguresReportsAPi(data, UUID)
      .then((response) => {
        dispatch(fetchEnd());
        if (response.data.response.length > 0) {
          dispatch(fetchEnd());
          dispatch(ratioKeyFiguresReportsSuccess(response.data.response));
          history.push('/ratio-key-figures-reports-results');
        } else {
          globalToast.showWarning('No records found.');
        }
      })
      .catch((error) => {
        dispatch(fetchEnd());
        dispatch(targetReportsFailed(error));
      });
  };
};

const getRatioKeyFiguresReportsAPi = (data, UUID) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  if (UUID) {
    result = axios.post(
      'attribute-ratio?app_type=Customer Rebate&data_source_type=Direct - Sales Data' +
      '&request_id=' +
      UUID,
      data,
      { headers: headers },
    );
  } else {
    result = axios.post(
      'attribute-ratio?app_type=Customer Rebate&data_source_type=Direct - Sales Data',
      data,
      { headers: headers },
    );
  }
  return result;
};
export const ratioKeyFiguresReportsSuccess = (data) => {
  return {
    type: RATIO_KEY_FIGURES_REPORTS_SUCCESS,
    data,
  };
};
// Incentive Ratio Trend Report
export const runIncentiveRatioTrendReports = (data, UUID) => {
  return (dispatch) => {
    dispatch(fetchStart());
    getIncentiveRatioTrendReportsAPi(data, UUID)
      .then((response) => {
        dispatch(fetchEnd());
        if (response.data.response.length > 0) {
          dispatch(fetchEnd());
          dispatch(IncentiveRatioTrendReportsSuccess(response.data.response));
          history.push('/incentive-ratio-trend-reports-results');
        } else {
          globalToast.showWarning('No records found.');
        }
      })
      .catch((error) => {
        dispatch(fetchEnd());
        dispatch(targetReportsFailed(error));
      });
  };
};

const getIncentiveRatioTrendReportsAPi = (data, UUID) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  if (UUID) {
    result = axios.post(
      'rebate-purchase-ratio',
      // 'attribute-ratio?app_type=Customer Rebate&data_source_type=Direct - Sales Data' + '&request_id=' + UUID,
      data,
      { headers: headers },
    );
  } else {
    result = axios.post('rebate-purchase-ratio', data, { headers: headers });
  }
  return result;
};
export const IncentiveRatioTrendReportsSuccess = (data) => {
  return {
    type: INCENTIVE_RATIO_TREND_REPORTS_SUCCESS,
    data,
  };
};

//customer Reconciliation report
export const runOutgoingClaimsReport = (data) => {
  return (dispatch) => {
    //console.log("Form Data sent to API:", data);
    dispatch(fetchStart());
    getOutgoingClaimsReportAPI(data)
      .then((response) => {
        dispatch(fetchEnd());
        if (response?.data?.response?.length > 0) {
          dispatch(outgoingClaimsReportSuccess(response.data.response));
          history.push('/customer-outgoing-reconciliation-reports-results');
        } else {
          globalToast.showWarning('No records found.');
        }
      })
      .catch((error) => {
        dispatch(fetchEnd());
        dispatch(targetReportsFailed(error));
      });
  };
};

const getOutgoingClaimsReportAPI = (data) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };

  let result = axios.post('/get-outgoing-claims', data, { headers });
  return result;
};

export const outgoingClaimsReportSuccess = (data) => {
  return {
    type: OUTGOING_CLAIMS_REPORT_SUCCESS,
    data,
  };
};
// Top N attributes Report
export const runTopNAttributesReports = (data, id) => {
  return (dispatch) => {
    dispatch(fetchStart());
    getTopNAttributesReportsAPi(data, id)
      .then((response) => {
        dispatch(fetchEnd());
        if (response.data.response.length > 0) {
          dispatch(fetchEnd());
          dispatch(topNAttributesReportsSuccess(response.data.response));
          history.push('/top-N-attributes-reports-results');
        } else {
          globalToast.showWarning('No records found.');
        }
      })
      .catch((error) => {
        dispatch(fetchEnd());
        dispatch(targetReportsFailed(error));
      });
  };
};

const getTopNAttributesReportsAPi = (data, id) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  let result = axios.post(
    'top-attribute-share?app_type=Customer Rebate&data_source_type=Direct - Sales Data&request_id=' +
    id,
    data,
    { headers: headers },
  );
  return result;
};
export const topNAttributesReportsSuccess = (data) => {
  return {
    type: TOP_N_ATTRIBUTES_REPORTS_SUCCESS,
    data,
  };
};
export const runCancelRequest = (data) => {
  return (dispatch) => {
    dispatch(fetchStart());
    getCancelRequestAPi(data)
      .then((response) => {
        dispatch(fetchEnd());
        if (response.data.message) {
          globalToast.showSuccess(response.data.message);
        }
        if (response.data.response) {
          globalToast.showSuccess(response.data.response);
        }
      })
      .catch((error) => {
        dispatch(fetchEnd());
        globalToast.showError(error.response.data.response);
      });
  };
};

const getCancelRequestAPi = (data) => {
  const config = {
    headers: {
      Authorization: secureLocalStorage.getItem('aTk'),
    },
    params: data,
  };
  let result = axios.get('cancel-request', config);
  return result;
};
// duplicate payment Report
export const runDuplicatePaymentReports = (data, UUID, postingTypeRadio) => {
  return (dispatch) => {
    dispatch(fetchStart());
    getDuplicatePaymentReportsAPi(data, UUID, postingTypeRadio)
      .then((response) => {
        dispatch(fetchEnd());
        if (
          response.data.response != null &&
          response.data.response.length > 0
        ) {
          dispatch(fetchEnd());
          dispatch(duplicatePaymentReportsSuccess(response.data.response));
          history.push('/duplicate-payment-reports-results');
        } else {
          globalToast.showWarning('No records found.');
        }
      })
      .catch((error) => {
        dispatch(fetchEnd());
        dispatch(targetReportsFailed(error));
      });
  };
};

const getDuplicatePaymentReportsAPi = (data, UUID, postingTypeRadio) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  if (UUID) {
    result = axios.post(
      'duplicate-payment?request_id=' +
      UUID +
      '&posting_type=' +
      postingTypeRadio,
      data,
      { headers: headers },
    );
    return result;
  } else {
    result = axios.post('duplicate-payment', data, { headers: headers });
    return result;
  }
};
export const duplicatePaymentReportsSuccess = (data) => {
  return {
    type: DUPLICATE_PAYMENT_REPORTS_SUCCESS,
    data,
  };
};
// Anamoly reports
export const runAnamolyReports = (data, UUID) => {
  return (dispatch) => {
    dispatch(fetchStart());
    getAnamolyReportsAPi(data, UUID)
      .then((response) => {
        dispatch(fetchEnd());
        if (
          response.data.response !== 'no anamolies detected' &&
          response.data.response.length > 0
        ) {
          dispatch(fetchEnd());
          dispatch(anamolyReportsSuccess(response.data.response));
          history.push('/anamoly-reports-results');
        } else {
          globalToast.showWarning(response.data.response);
        }
      })
      .catch((error) => {
        dispatch(fetchEnd());
        dispatch(targetReportsFailed(error));
      });
  };
};

const getAnamolyReportsAPi = (data, UUID) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  if (UUID) {
    result = axios.post('detect-anamolies?request_id=' + UUID, data, {
      headers: headers,
    });
  } else {
    result = axios.post('detect-anamolies', data, { headers: headers });
  }
  return result;
};
export const anamolyReportsSuccess = (data) => {
  return {
    type: ANAMOLY_REPORTS_SUCCESS,
    data,
  };
};
// approval posting History
export const runApprovalPostingHistoryReports = (data, UUID) => {
  return (dispatch) => {
    dispatch(fetchStart());
    getApprovalPostingHistoryReportsAPi(data, UUID)
      .then((response) => {
        dispatch(fetchEnd());
        if (
          response.data.response != null &&
          response.data.response.length > 0
        ) {
          dispatch(fetchEnd());
          dispatch(getApprovalPostingHistorySucsses(response.data.response));
          history.push('/approval-posting-history-reports-results');
        } else {
          globalToast.showWarning('No records found.');
        }
      })
      .catch((error) => {
        dispatch(fetchEnd());
        dispatch(targetReportsFailed(error));
      });
  };
};

const getApprovalPostingHistoryReportsAPi = (data, UUID) => {
  for (let propName in data) {
    if (
      data[propName] === '' ||
      data[propName] === null ||
      data[propName] === undefined ||
      data[propName].length === 0 ||
      data[propName] === '1970-01-01T00:00:00.000Z,1970-01-01T00:00:00.000Z' ||
      data[propName] === '1970-01-01T00:00:00.000Z' ||
      data[propName] === ','
    ) {
      delete data[propName];
    }
  }
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  if (UUID) {
    result = axios.post(
      'approval-history?application_type=Customer Rebate' +
      '&request_id=' +
      UUID,
      data,
      { headers: headers },
    );
  } else {
    result = axios.post(
      'approval-history?application_type=Customer Rebate',
      data,
      { headers: headers },
    );
  }
  return result;
};
export const getApprovalPostingHistorySucsses = (data) => {
  return {
    type: APPROVAL_POSTING_HISTORY_REPORTS_SUCCESS,
    data,
  };
};

//Contract History Approval

export const contractHistoryApprovalReports = (data, funtionality) => {
  return (dispatch) => {
    dispatch(fetchStart());
    getContractHistoryApprovalReportsAPi(data, funtionality)
      .then((response) => {
        dispatch(fetchEnd());
        if (response.data.response && response.data.response.length > 0) {
          dispatch(fetchEnd());
          dispatch(getContractHistoryApprovalSucsses(response.data.response));
          history.push('/contract-history-approval-reports-results');
        } else {
          globalToast.showWarning('No records found.');
        }
      })
      .catch((error) => {
        dispatch(fetchEnd());
        dispatch(targetReportsFailed(error));
      });
  };
};

const getContractHistoryApprovalReportsAPi = (data, funtionality) => {
  for (let propName in data) {
    if (
      data[propName] === '' ||
      data[propName] === null ||
      data[propName] === undefined ||
      data[propName].length === 0 ||
      data[propName] === '1970-01-01T00:00:00.000Z,1970-01-01T00:00:00.000Z' ||
      data[propName] === '1970-01-01T00:00:00.000Z' ||
      data[propName] === ','
    ) {
      delete data[propName];
    }
  }
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;

  result = axios.post(
    'contracts/history-data?application_type=Customer Rebate' +
    '&functionality=' +
    funtionality,
    data,
    { headers: headers },
  );

  return result;
};
export const getContractHistoryApprovalSucsses = (data) => {
  return {
    type: CONTRACT_HISTORY_APPROVAL_SUCCESS,
    data,
  };
};

//Document History Approval
export const documentHistoryApprovalReports = (data) => {
  return (dispatch) => {
    dispatch(fetchStart());
    getDocumentHistoryApprovalReportsAPi(data)
      .then((response) => {
        dispatch(fetchEnd());
        if (response.data.response && response.data.response.length > 0) {
          dispatch(fetchEnd());
          dispatch(getDocumentHistoryApprovalSucsses(response.data.response));
          history.push('/document-history-approval-reports-results');
        } else {
          globalToast.showWarning('No records found.');
        }
      })
      .catch((error) => {
        dispatch(fetchEnd());
        dispatch(targetReportsFailed(error));
      });
  };
};

const getDocumentHistoryApprovalReportsAPi = (data) => {
  for (let propName in data) {
    if (
      data[propName] === '' ||
      data[propName] === null ||
      data[propName] === undefined ||
      data[propName].length === 0 ||
      data[propName] === '1970-01-01T00:00:00.000Z,1970-01-01T00:00:00.000Z' ||
      data[propName] === '1970-01-01T00:00:00.000Z' ||
      data[propName] === ','
    ) {
      delete data[propName];
    }
  }
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;

  result = axios.post('document-approval-history', data, { headers: headers });

  return result;
};
export const getDocumentHistoryApprovalSucsses = (data) => {
  return {
    type: DOCUMENT_HISTORY_APPROVAL_SUCCESS,
    data,
  };
};

//NTE Life Time
export const getNTELifeTimeReports = (data) => {
  return (dispatch) => {
    dispatch(fetchStart());
    getNTELifeTimeReportsAPI(data)
      .then((response) => {
        dispatch(fetchEnd());
        if (response.data.response && response.data.response.length > 0) {
          dispatch(fetchEnd());
          dispatch(getNTELifeTimeReportsSucsses(response.data.response));
          history.push('/nte-lifetime-reports-results');
        } else {
          globalToast.showWarning('No records found.');
        }
      })
      .catch((error) => {
        dispatch(fetchEnd());
        dispatch(targetReportsFailed(error));
      });
  };
};

const getNTELifeTimeReportsAPI = (data) => {
  for (let propName in data) {
    if (
      data[propName] === '' ||
      data[propName] === null ||
      data[propName] === undefined ||
      data[propName].length === 0 ||
      data[propName] === '1970-01-01T00:00:00.000Z,1970-01-01T00:00:00.000Z' ||
      data[propName] === '1970-01-01T00:00:00.000Z' ||
      data[propName] === ','
    ) {
      delete data[propName];
    }
  }
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;

  result = axios.post('contracts/nte-report', data, { headers: headers });

  return result;
};
export const getNTELifeTimeReportsSucsses = (data) => {
  return {
    type: NTE_LIFE_TIME_SUCCESS,
    data,
  };
};

// ESimulate Rebate Estimator
export const runSimulateRebateEstimator = (data, type) => {
  return (dispatch) => {
    dispatch(fetchStart());
    getSimulateRebateEstimatorAPI(data)
      .then((response) => {
        dispatch(fetchEnd());
        if (response.data) {
          dispatch(fetchEnd());
          let data = response.data.response
          data = data.map((item) => {
            return {
              ...item.summary,
              formula_details: item.formula_details,
              rules: item.rules
            }
          }
          )
          if (type == 'execute')
            history.push('/next-tier-simulation-result');
          dispatch(getSimulateRebateEstimatorSuccess(data));
        } else {
          globalToast.showWarning('No records found.');
        }
      })
      .catch((error) => {
        dispatch(fetchEnd());
      });
  };
};

const getSimulateRebateEstimatorAPI = (data) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  let result;
  result = axios.post('purchase/rebate-estimator', data, { headers: headers });
  return result
};
export const getSimulateRebateEstimatorSuccess = (data) => {
  return {
    type: SIMULATE_REBATE_ESTIMATOR,
    data,
  };
};

export const clearSimulateRebateEstimator = () => {
  return {
    type: CLEAR_SIMULATE_REBATE_ESTIMATOR,
  };
};

export const saveRebateEstimatorState = (data) => ({
  type: SAVE_SIMULATE_REBATE_ESTIMATOR_STATE,
  payload: data
});

export const clearRebateEstimatorState = () => ({
  type: CLEAR_SIMULATE_REBATE_ESTIMATOR_STATE,
});

// Excel Contract Search by Customer
export const runExceptionSearchByCustomer = (data) => {
  return (dispatch) => {
    dispatch(fetchStart());
    getExceptionSearchByCustomerAPI(data)
      .then((response) => {
        dispatch(fetchEnd());
        if (response.data) {
          dispatch(fetchEnd());
          dispatch(getExceptionSearchByCustomerSuccess(response.data));
        } else {
          globalToast.showWarning('No records found.');
        }
      })
      .catch((error) => {
        dispatch(fetchEnd());
      });
  };
};

const getExceptionSearchByCustomerAPI = (data) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.post('customer/contract', data, { headers: headers });

  return result;
};
export const getExceptionSearchByCustomerSuccess = (data) => {
  return {
    type: EXCEPTION_SEARCH_BY_CUSTOMER,
    data,
  };
};

export const saveSimulationState = (data) => ({
  type: SAVE_SIMULATION_STATE,
  payload: data
});

export const clearSimulationState = () => ({
  type: CLEAR_SIMULATION_STATE,
});

export const clearExceptionSearchByCustomer = () => {
  return {
    type: CLEAR_EXCEPTION_SEARCH_BY_CUSTOMER,
  };
};

// run Formula Exception
export const runFormulaException = (data) => {
  return (dispatch) => {
    dispatch(fetchStart(EXCEPTION_FETCH_START));
    getFormulaExceptionAPI(data)
      .then((response) => {
        dispatch(fetchEnd(EXCEPTION_FETCH_END));
        if (response.data) {
          dispatch(getFormulaExceptionSucssess(response.data));
          if (response?.data?.response?.response?.length > 0)
            history.push('/exception-simulation-results');
          else
            globalToast.showWarning('No records found for selected contracts');
        } else {
          globalToast.showWarning('No records found for selected contracts');
        }
      })
      .catch((error) => {
        dispatch(fetchEnd(EXCEPTION_FETCH_END));
      });
  };
};

const getFormulaExceptionAPI = (data) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.post('simulate/rebate-calculation', data, { headers: headers });

  return result;
};
export const getFormulaExceptionSucssess = (data) => {
  return {
    type: FORMULA_EXCEPTION,
    data,
  };
};

export const clearFormulaException = () => {
  return {
    type: CLEAR_FORMULA_EXCEPTION,
  };
};

//Contract Search By Customer
export const runContractSearchByCustomer = (data, UUID) => {
  return (dispatch) => {
    dispatch(fetchStart());
    getContractSearchByCustomerAPI(data, UUID)
      .then((response) => {
        dispatch(fetchEnd());
        if (response.data) {
          dispatch(fetchEnd());
          dispatch(getContractSearchByCustomerSucsses(response.data));
          history.push('/contract-search-by-customer-results');
        } else {
          globalToast.showWarning('No records found.');
        }
      })
      .catch((error) => {
        dispatch(fetchEnd());
      });
  };
};

const getContractSearchByCustomerAPI = (data, UUID) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  // let result = axios.get("contracts/customer-details", {
  //   headers: headers,
  //   params: data,
  // });
  var result;
  if (UUID) {
    result = axios.get(
      'contracts/customer-details',
      { params: data, headers: headers },
    );
    // result = axios.get('contracts/customer-details/' + data + '&request_id=' + UUID, {
    //   headers: headers,
    // });
  } else {
    result = axios.get('contracts/customer-details?' + data, {
      headers: headers,
    });
  }
  return result;
};
export const getContractSearchByCustomerSucsses = (data) => {
  return {
    type: CONTRACT_SEARCH_BY_CUSTOMER,
    data,
  };
};

export const contractChangeReportsSuccess = (data) => {
  return {
    type: CONTRACT_CHANGE_REPORTS_SUCCESS,
    data,
  };
};

export const contractChangeReportsFailed = (data) => {
  return {
    type: CONTRACT_CHANGE_REPORTS_FAILED,
    data,
  };
};

export const runcontractChangeReports = (pagination, limit, type) => {
  return (dispatch) => {
    dispatch(fetchStart());
    getcontractChangeReportsAPi(pagination, limit, type)
      .then((response) => {
        dispatch(fetchEnd());
        if (
          response &&
          response.data &&
          response.data.response &&
          response.data.response.records?.length &&
          response.data.response.records?.length > 0
        ) {
          dispatch(fetchEnd());
          dispatch(contractChangeReportsSuccess(response.data.response));
          history.push('/contract-change-reports/result');
        } else {
          dispatch(contractChangeReportsSuccess(response.data.response));
          globalToast.showWarning('No records found.');
        }
      })
      .catch((error) => {
        dispatch(fetchEnd());
        dispatch(contractChangeReportsFailed(error));
      });
  };
};

const getcontractChangeReportsAPi = (pagination, limit, type) => {
  const data = JSON.parse(sessionStorage.getItem('ContractChangeReportsData'));
  for (let propName in data) {
    if (
      data[propName] === '' ||
      data[propName] === null ||
      data[propName] === undefined ||
      data[propName].length === 0 ||
      data[propName] === '1970-01-01T00:00:00.000Z,1970-01-01T00:00:00.000Z' ||
      data[propName] === '1970-01-01T00:00:00.000Z' ||
      data[propName] === ','
    ) {
      delete data[propName];
    }
  }
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  let result;
  if (type === 'all-changes') {
    result = axios.get(
      'audit-contract-list?page=' +
      pagination +
      '&limit=' +
      limit +
      '&application_type=' +
      sessionStorage.getItem('application'),
      { params: data, headers: headers },
    );
  } else if (type === 'pending-changes') {
    result = axios.get(
      'audit-contract-list?page=' +
      pagination +
      '&limit=' +
      limit +
      '&pending-change=true' +
      '&application_type=' +
      sessionStorage.getItem('application'),
      { params: data, headers: headers },
    );
  } else if (type === 'approved') {
    result = axios.get(
      'audit-contract-list?page=' +
      pagination +
      '&limit=' +
      limit +
      '&approved=true' +
      '&application_type=' +
      sessionStorage.getItem('application'),
      { params: data, headers: headers },
    );
  } else {
    result = axios.get(
      'contract-change-log-list?page=' + pagination + '&limit=' + limit,
      { params: data, headers: headers },
    );
  }
  return result;
};

export const financialSummarySuccess = (data) => {
  return {
    type: FINANCIAL_SUMMARY_SUCCESS,
    data,
  };
};

export const financialSummaryFailed = (data) => {
  return {
    type: FINANCIAL_SUMMARY_FAILED,
    data,
  };
};


export const runFinancialSummary = (pagination, limit, keyword) => {
  return (dispatch) => {
    dispatch(fetchStart());
    getFinancialSummaryAPi(pagination, limit, keyword)
      .then((response) => {
        dispatch(fetchEnd());
        if (response.data.response.records?.length > 0) {
          dispatch(fetchEnd());
          dispatch(financialSummarySuccess(response.data.response));
          history.push('/financial-approvals-reports/result');
          dispatch(
            runFinancialSummaryComplete(response.data.response.records?.length),
          );
        } else {
          //globalToast.showError("Zero records found.");
        }
      })
      .catch((error) => {
        dispatch(fetchEnd());
        dispatch(financialSummaryFailed(error));
      });
  };
};

const getFinancialSummaryAPi = (pagination, limit, keyword) => {
  const data = JSON.parse(localStorage.getItem('FinancialSummaryPosting'));
  for (let propName in data) {
    if (
      data[propName] === '' ||
      data[propName] === null ||
      data[propName] === undefined ||
      data[propName].length === 0 ||
      data[propName] === '1970-01-01T00:00:00.000Z,1970-01-01T00:00:00.000Z' ||
      data[propName] === '1970-01-01T00:00:00.000Z' ||
      data[propName] === ','
    ) {
      delete data[propName];
    }
  }
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  let result;
  if (keyword) {
    result = axios.get(
      'financial_postings/grouped?page=' +
      pagination +
      '&limit=' +
      limit +
      '&keyword=' +
      keyword,
      { params: data, headers: headers },
    );
  } else {
    result = axios.get(
      'financial_postings/grouped?page=' + pagination + '&limit=' + limit,
      { params: data, headers: headers },
    );
  }
  return result;
};

export const invoiceReportsSuccess = (data) => {
  return {
    type: INVOICE_REPORTS_SUCCESS,
    data,
  };
};

export const invoiceReportsFailed = (data) => {
  return {
    type: INVOICE_REPORTS_FAILED,
    data,
  };
};

export const runInvoiceReports = (pagination, limit, keyword) => {
  return (dispatch) => {
    dispatch(fetchStart());
    getInvoiceReportsAPi(pagination, limit, keyword)
      .then((response) => {
        if (response.data.response.records.length > 0) {
          dispatch(fetchEnd());
          dispatch(invoiceReportsSuccess(response.data.response));
          history.push('/invoice-details-reports/invoice-reports');
          dispatch(
            runInvoiceReportsComplete(response.data.response.records?.length),
          );
        } else {
          dispatch(fetchEnd());
          globalToast.showWarning('No records found.');
        }
      })
      .catch((error) => {
        dispatch(fetchEnd());
        dispatch(invoiceReportsFailed(error));
      });
  };
};

const getInvoiceReportsAPi = (pagination, limit, keyword) => {
  let data = JSON.parse(sessionStorage.getItem('InvoiceReportsData'));
  for (let propName in data) {
    if (
      data[propName] === '' ||
      data[propName] === null ||
      data[propName] === undefined ||
      data[propName].length === 0 ||
      data[propName] === '1970-01-01T00:00:00.000Z,1970-01-01T00:00:00.000Z' ||
      data[propName] === '1970-01-01T00:00:00.000Z' ||
      data[propName] === ','
    ) {
      delete data[propName];
    }
  }
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  let result;
  if (keyword === 'noFilter') {
    result = axios.get('sales_data?page=' + pagination + '&limit=' + limit, {
      headers: headers,
    });
  } else if (keyword) {
    result = axios.get(
      'sales_data?page=' +
      pagination +
      '&limit=' +
      limit +
      '&keyword=' +
      keyword,
      { params: data, headers: headers },
    );
  } else {
    result = axios.get(
      'sales_data?page=' + pagination + '&limit=' + limit,
      { params: data, headers: headers },
    );
  }
  return result;
};

export const invoiceReportsCompleteSuccess = (data) => {
  return {
    type: INVOICE_REPORTS_COMPLETE_SUCCESS,
    data,
  };
};

export const runInvoiceReportsComplete = (totalRecords) => {
  return (dispatch) => {
    getInvoiceReportsCompleteApi(totalRecords)
      .then((response) => {
        if (response.data.response.records.length > 0) {
          dispatch(invoiceReportsCompleteSuccess(response.data.response));
        }
      })
      .catch((error) => { });
  };
};

const getInvoiceReportsCompleteApi = (totalRecords) => {
  let data = JSON.parse(sessionStorage.getItem('InvoiceReportsData'));
  for (let propName in data) {
    if (
      data[propName] === '' ||
      data[propName] === null ||
      data[propName] === undefined ||
      data[propName].length === 0 ||
      data[propName] === '1970-01-01T00:00:00.000Z,1970-01-01T00:00:00.000Z' ||
      data[propName] === '1970-01-01T00:00:00.000Z' ||
      data[propName] === ','
    ) {
      delete data[propName];
    }
  }
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  const result = axios.get(
    'sales_data?limit=' + totalRecords,
    { params: data, headers: headers },
  );
  return result;
};

export const contractReportsSuccess = (data) => {
  return {
    type: CONTRACT_REPORTS_SUCCESS,
    data,
  };
};

export const contractReportsFailed = (data) => {
  return {
    type: CONTRACT_REPORTS_FAILED,
    data,
  };
};

export const runContractReports = (pagination, limit, keyword, overlap) => {
  return (dispatch) => {
    dispatch(fetchStart());
    getContractReportsAPI(pagination, limit, keyword, overlap)
      .then((response) => {
        dispatch(fetchEnd());
        if (overlap === 'overlap') {
          if (response.data.response.length > 0) {
            dispatch(contractReportsOverlapSuccess(response.data.response));
            history.push('/contract-overlap-reports/contract-overlap-reports');
          } else {
            globalToast.showWarning('No records found.');
          }
        } else {
          if (response.data.response.records.length > 0) {
            dispatch(contractReportsSuccess(response.data.response));
            history.push('/contract-reports/contract-reports-results');
            dispatch(
              runContractReportsComplete(
                response.data.response.records?.length,
              ),
            );
          } else {
            globalToast.showWarning('No records found.');
            dispatch(fetchEnd());
          }
        }
      })
      .catch((error) => {
        dispatch(fetchEnd());
        dispatch(invoiceReportsFailed(error));
      });
  };
};

export const contractReportsOverlapSuccess = (data) => {
  return {
    type: CONTRACT_REPORTS_OVERLAP_SUCCESS,
    data,
  };
};

const getContractReportsAPI = (pagination, limit, keyword, overlap) => {
  let data = JSON.parse(sessionStorage.getItem('ContractReportsData'));
  for (let propName in data) {
    if (
      data[propName] === '' ||
      data[propName] === null ||
      data[propName] === undefined ||
      data[propName].length === 0 ||
      data[propName] === '1970-01-01T00:00:00.000Z,1970-01-01T00:00:00.000Z' ||
      data[propName] === '1970-01-01T00:00:00.000Z' ||
      data[propName] === ','
    ) {
      delete data[propName];
    }
  }
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  let result;
  if (keyword === 'noFilter' && overlap != 'overlap') {
    result = axios.get('contracts?page=' + pagination + '&limit=' + limit, {
      headers: headers,
    });
  } else if (keyword && overlap != 'overlap') {
    result = axios.get(
      'contracts?page=' +
      pagination +
      '&limit=' +
      limit +
      '&keyword=' +
      keyword,
      { params: data, headers: headers },
    );
  } else {
    if (overlap === 'overlap' && keyword != 'noFilter') {
      result = axios.get(
        'contracts?overlap=true&page=' + pagination + '&limit=' + limit,
        { params: data, headers: headers },
      );
    } else if (overlap === 'overlap' && keyword === 'noFilter') {
      result = axios.get(
        'contracts?overlap=true&page=' + pagination + '&limit=' + limit,
        { headers: headers },
      );
    } else {
      result = axios.get(
        'contracts?page=' + pagination + '&limit=' + limit,
        { params: data, headers: headers },
      );
    }
  }
  return result;
};

export const contractReportsCompleteSuccess = (data) => {
  return {
    type: CONTRACT_REPORTS_COMPLETE_SUCCESS,
    data,
  };
};

export const runContractReportsComplete = (totalRecords) => {
  return (dispatch) => {
    getContractReportsCompleteAPI(totalRecords).then((response) => {
      if (response.data.response.records.length > 0) {
        dispatch(contractReportsCompleteSuccess(response.data.response));
      }
    });
  };
};

const getContractReportsCompleteAPI = (totalRecords) => {
  let data = JSON.parse(sessionStorage.getItem('ContractReportsData'));
  for (let propName in data) {
    if (
      data[propName] === '' ||
      data[propName] === null ||
      data[propName] === undefined ||
      data[propName].length === 0 ||
      data[propName] === '1970-01-01T00:00:00.000Z,1970-01-01T00:00:00.000Z' ||
      data[propName] === '1970-01-01T00:00:00.000Z' ||
      data[propName] === ','
    ) {
      delete data[propName];
    }
  }
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  const result = axios.get(
    'contracts?limit=' + totalRecords,
    { params: data, headers: headers },
  );
  return result;
};

export const downloadSheet = (data, name) => {
  return (dispatch) => {
    getDownloadSheetApi(data, name).then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      let date = Date.now();
      link.setAttribute('download', date + '.xlsx'); //or any other extension
      document.body.appendChild(link);
      link.click();
    });
  };
};

const getDownloadSheetApi = (data, name) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  const result = axios.post('generate-excel-sheet/' + name, data, {
    headers: headers,
    responseType: 'blob',
  });
  return result;
};

export const calculationReportsCompleteSuccess = (data) => {
  return {
    type: CALCULATION_REPORTS_COMPLETE_SUCCESS,
    data,
  };
};

export const runCalculationReportsComplete = (totalRecords) => {
  return (dispatch) => {
    getCalculationReportsCompleteApi(totalRecords)
      .then((response) => {
        if (response.data.response.records?.length > 0) {
          dispatch(calculationReportsCompleteSuccess(response.data.response));
        } else {
          //globalToast.showError("Zero records found.");
        }
      })
      .catch((error) => { });
  };
};

const getCalculationReportsCompleteApi = (totalRecords) => {
  const data = JSON.parse(sessionStorage.getItem('CalculationReportsData'));
  for (let propName in data) {
    if (
      data[propName] === '' ||
      data[propName] === null ||
      data[propName] === undefined ||
      data[propName].length === 0 ||
      data[propName] === '1970-01-01T00:00:00.000Z,1970-01-01T00:00:00.000Z' ||
      data[propName] === '1970-01-01T00:00:00.000Z' ||
      data[propName] === ','
    ) {
      delete data[propName];
    }
  }
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  const result = axios.get(
    'calculation_simulations?limit=' + totalRecords,
    { params: data, headers: headers },
  );
  return result;
};

export const targetReportsCompleteSuccess = (data) => {
  return {
    type: TARGET_REPORTS_COMPLETE_SUCCESS,
    data,
  };
};

export const runTargetReportsComplete = (totalRecords) => {
  return (dispatch) => {
    getTargetReportsCompleteApi(totalRecords)
      .then((response) => {
        if (response.data.response.records?.length > 0) {
          dispatch(targetReportsCompleteSuccess(response.data.response));
        }
      })
      .catch((error) => { });
  };
};

const getTargetReportsCompleteApi = (totalRecords) => {
  const data = JSON.parse(sessionStorage.getItem('TargetReportsData'));
  for (let propName in data) {
    if (
      data[propName] === '' ||
      data[propName] === null ||
      data[propName] === undefined ||
      data[propName].length === 0 ||
      data[propName] === '1970-01-01T00:00:00.000Z,1970-01-01T00:00:00.000Z' ||
      data[propName] === '1970-01-01T00:00:00.000Z' ||
      data[propName] === ','
    ) {
      delete data[propName];
    }
  }
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  const result = axios.get(
    'target-data-report?limit=' + totalRecords,
    { params: data, headers: headers },
  );
  return result;
};

export const contractChangeReportsCompleteSuccess = (data) => {
  return {
    type: CONTRACT_CHANGE_REPORTS_COMPLETE_SUCCESS,
    data,
  };
};

export const runContractChangeReportsComplete = (totalRecords) => {
  return (dispatch) => {
    getContractChangeReportsCompleteApi(totalRecords)
      .then((response) => {
        if (response.data.response.records?.length > 0) {
          dispatch(
            contractChangeReportsCompleteSuccess(response.data.response),
          );
        } else {
          //globalToast.showError("Zero records found.");
        }
      })
      .catch((error) => { });
  };
};

const getContractChangeReportsCompleteApi = (totalRecords) => {
  const data = JSON.parse(sessionStorage.getItem('ContractChangeReportsData'));
  for (let propName in data) {
    if (
      data[propName] === '' ||
      data[propName] === null ||
      data[propName] === undefined ||
      data[propName].length === 0 ||
      data[propName] === '1970-01-01T00:00:00.000Z,1970-01-01T00:00:00.000Z' ||
      data[propName] === '1970-01-01T00:00:00.000Z' ||
      data[propName] === ','
    ) {
      delete data[propName];
    }
  }
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  const result = axios.get(
    'contract-change-log-list?limit=' + totalRecords,
    { params: data, headers: headers },
  );
  return result;
};

export const financialSummaryCompleteSuccess = (data) => {
  return {
    type: FINANCIAL_SUMMARY_COMPLETE_SUCCESS,
    data,
  };
};

export const runFinancialSummaryComplete = (totalRecords) => {
  return (dispatch) => {
    getFinancialSummaryCompleteApi(totalRecords)
      .then((response) => {
        if (response.data.response.records?.length > 0) {
          dispatch(financialSummaryCompleteSuccess(response.data.response));
        } else {
          //globalToast.showError("Zero records found.");
        }
      })
      .catch((error) => { });
  };
};

const getFinancialSummaryCompleteApi = (totalRecords) => {
  const data = JSON.parse(localStorage.getItem('FinancialSummaryPosting'));
  for (let propName in data) {
    if (
      data[propName] === '' ||
      data[propName] === null ||
      data[propName] === undefined ||
      data[propName].length === 0 ||
      data[propName] === '1970-01-01T00:00:00.000Z,1970-01-01T00:00:00.000Z' ||
      data[propName] === '1970-01-01T00:00:00.000Z' ||
      data[propName] === ','
    ) {
      delete data[propName];
    }
  }
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  const result = axios.get(
    'financial_postings/grouped?limit=' + totalRecords,
    { params: data, headers: headers },
  );
  return result;
};

export const searchInvoice = (keyword) => {
  return (dispatch) => {
    if (keyword) {
      getSearchInvoiceApi(keyword)
        .then((response) => {
          dispatch(invoiceReportsSuccess(response.data.response));
        })
        .catch((error) => { });
    } else {
      dispatch(runInvoiceReports(0, 10));
    }
  };
};

const getSearchInvoiceApi = (keyword) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  let result;
  result = axios.get('sales-data-search?keyword=' + keyword, {
    headers: headers,
  });
  return result;
};

export const getDynamicQueryFields = () => {
  return (dispatch) => {
    getDynamicQueryFieldsApi().then((response) => {
      dispatch(getDynamicQueryFieldsApiSuccess(response.data.response));
    });
  };
};

const getDynamicQueryFieldsApi = () => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  let result;
  result = axios.get('financial-posting-fields', { headers: headers });
  return result;
};

export const getDynamicQueryFieldsApiSuccess = (data) => {
  sessionStorage.setItem('dq_table_name', data.table_name);
  return {
    type: DYNAMIC_QUERY_FIELDS_SUCCESS,
    data,
  };
};

export const getPurchaseDataFields = () => {
  return (dispatch) => {
    getPurchaseDataFieldsAPI().then((response) => {
      dispatch(getPurchaseDataFieldsAPISuccess(response.data.response));
    });
  };
};

const getPurchaseDataFieldsAPI = () => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  let result;
  result = axios.get('purchase-data-fields', { headers: headers });
  return result;
};

export const getPurchaseDataFieldsAPISuccess = (data) => {
  sessionStorage.setItem('dq_table_name', data.table_name);
  return {
    type: DYNAMIC_QUERY_FIELDS_SUCCESS,
    data,
  };
};

export const getQueryTypes = () => {
  return (dispatch) => {
    getQueryTypesAPI().then((response) => {
      dispatch(getQueryTypesAPISuccess(response.data));
    });
  };
};

const getQueryTypesAPI = () => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  let result;
  result = axios.get('get-query-types', { headers: headers });
  return result;
};

export const getQueryTypesAPISuccess = (data) => {
  return {
    type: QUERY_TYPES_SUCCESS,
    data,
  };
};

export const getDynamicQuerySalesDataFields = () => {
  return (dispatch) => {
    getDynamicQuerySalesDataFieldsAPI().then((response) => {
      dispatch(
        getDynamicQuerySalesDataFieldsAPISuccess(response.data.response),
      );
    });
  };
};

const getDynamicQuerySalesDataFieldsAPI = () => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  let result;
  result = axios.get('sales-data-fields', { headers: headers });
  return result;
};

export const getDynamicQuerySalesDataFieldsAPISuccess = (data) => {
  sessionStorage.setItem('dq_table_name', data.table_name);
  return {
    type: DYNAMIC_QUERY_FIELDS_SUCCESS,
    data,
  };
};

export const getCalculationSimulationDataFields = () => {
  return (dispatch) => {
    getCalculationSimulationDataFieldsAPI().then((response) => {
      dispatch(
        getCalculationSimulationDataFieldsSuccess(response.data.response),
      );
    });
  };
};

const getCalculationSimulationDataFieldsAPI = () => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  let result;
  result = axios.get('calculation-simulation-fields', { headers: headers });
  return result;
};

export const getCalculationSimulationDataFieldsSuccess = (data) => {
  sessionStorage.setItem('dq_table_name', data.table_name);
  return {
    type: DYNAMIC_QUERY_FIELDS_SUCCESS,
    data,
  };
};

export const getQueryList = (pagination, limit, queryType, app) => {
  return (dispatch) => {
    dispatch(getQueryListApiSuccess({}));
    dispatch(fetchStart());
    getQueryListApi(pagination, limit, queryType).then((response) => {
      dispatch(fetchEnd());
      dispatch(getQueryListApiSuccess(response.data.response));
    });
  };
};

const getQueryListApi = (pagination, limit, queryType) => {
  const app = sessionStorage.getItem('application');
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  let result;
  if (app === 'Audit Lab') {
    result = axios.get(
      'dynamic-query-formats-all?page=' +
      pagination +
      '&query_type=' +
      queryType +
      '&limit=' +
      limit,
      { headers: headers },
    );
  } else if (sessionStorage.getItem('application') === 'Collaboration Portal') {
    result = axios.get(
      'dynamic-query-formats-all?page=' +
      pagination +
      '&query_type=' +
      queryType +
      '&limit=' +
      limit,
      { headers: headers },
    );
  } else {
    result = axios.get(
      'dynamic-query-formats-all?page=' +
      pagination +
      '&query_type=' +
      queryType +
      '&limit=' +
      limit
      // + '&app_type=' + app
      ,
      { headers: headers },
    );
  }
  return result;
};

export const getQueryListApiSuccess = (data) => {
  return {
    type: QUERY_LIST_SUCCESS,
    data,
  };
};

export const getQueryListAdmin = () => {
  return (dispatch) => {
    getQueryListAdminAPI().then((response) => {
      dispatch(getQueryListAdminSuccess(response.data.response));
    });
  };
};

const getQueryListAdminAPI = () => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  let result;
  result = axios.get('admin-dynamic-query-formats-all', { headers: headers });
  return result;
};

export const getQueryListAdminSuccess = (data) => {
  return {
    type: QUERY_LIST_ADMIN_SUCCESS,
    data,
  };
};

export const postDynamicQuery = (data, mode, page) => {
  return (dispatch) => {
    postDynamicQueryApi(data, mode)
      .then((response) => {
        if (page.includes('partner')) {
          if (mode === 'edit') {
            globalToast.showSuccess('Succesfully updated !');
          } else {
            globalToast.showSuccess('Succesfully added !');
          }
          history.push('/partner-statement');
        }
        if (page.includes('collaboration')) {
          if (mode === 'edit') {
            globalToast.showSuccess('Succesfully updated !');
          } else {
            globalToast.showSuccess('Succesfully added !');
          }
          history.push('/collaboration-portal');
        }
        if (page.includes('on-demand-analytics')) {
          if (mode === 'edit') {
            globalToast.showSuccess('Succesfully updated !');
          } else {
            globalToast.showSuccess('Succesfully added !');
          }
          history.push('/on-demand-analytics');
        }
        if (page.includes('dynamic-query')) {
          if (mode === 'edit') {
            globalToast.showSuccess('Succesfully updated !');
          } else {
            globalToast.showSuccess('Succesfully added !');
          }
          history.push({
            pathname: '/dynamic-query',
            state: { application: 'Data Insights' },
          });
        }
      })
      .catch((error) => { });
  };
};
const postDynamicQueryApi = (data, mode) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  let result;
  if (mode === 'edit') {
    result = axios.put('dynamic-query-format/' + data.id, data, {
      headers: headers,
    });
  } else {
    result = axios.post('dynamic-query-format', data, { headers: headers });
  }
  return result;
};

export const runDynamicQuery = (data, id, dq, page, reset, UUID) => {
  let id_1 = JSON.parse(sessionStorage.getItem('dynamic_filter_fields')).id;
  return (dispatch) => {
    dispatch(fetchStart());
    if (reset == 'reset') {
      dispatch(fetchEnd());
      dispatch(runDynamicQueryApiSuccess([]));
    } else
      runDynamicQueryApi(data, id, dq, page, reset, UUID)
        .then((response) => {
          if (reset != 'reset') {
            if (response.data.response && response.data.response.length === 0) {
              dispatch(fetchEnd());
              globalToast.showWarning('No records found');
            } else if (
              response.data.response &&
              response.data.response.length > 0
            ) {
              dispatch(runDynamicQueryApiSuccess(response.data.response));
              dispatch(fetchEnd());
              if (dq === 'dynamicAnalytics') {
                history.push(
                  '/on-demand-analytics/on-demand-analytics-form/results/' +
                  id_1,
                );
              } else if (dq === 'dq') {
                if (
                  sessionStorage.getItem('dynamic_filter_fields') &&
                  JSON.parse(sessionStorage.getItem('dynamic_filter_fields')).id
                ) {
                  if (page === 'collaboration')
                    history.push(
                      '/collaboration-portal/collaboration-portal-form/results/' +
                      id_1,
                    );
                  else if (page === 'paymentpartner') {
                    history.push(
                      '/partner-statement/partner-statement-form/results/' +
                      id_1,
                    );
                  } else {
                    //if (localStorage.getItem("SFDQ"))
                    if (reset == 'sync-data')
                      history.push(
                        '/dynamic-query/dynamic-query-form-sf/results/' + id_1,
                      );
                    else
                      history.push(
                        '/dynamic-query/dynamic-query-form/results/' + id_1,
                      );
                  }
                }
              } else {
                if (page === 'collaboration')
                  history.push(
                    '/collaboration-portal/collaboration-portal-form/results/' +
                    id_1,
                  );
                else if (page === 'paymentpartner') {
                  history.push(
                    '/partner-statement/partner-statement-form/results/' + id_1,
                  );
                } else {
                  if (!sessionStorage.getItem('SFDQ')) {
                    history.push(
                      '/dynamic-query/dynamic-query-form/results/' + id_1,
                    );
                  } else {
                    history.push(
                      '/dynamic-query/dynamic-query-form-sf/results/' + id_1,
                    );
                  }
                }
              }
            }
          }
        })
        .catch((error) => {
          dispatch(fetchEnd());
          if (
            error &&
            error.response &&
            error.response.data &&
            error.response.data.message &&
            error.response.data.status == 413
          ) {
            globalToast.showWarning(error.response.data.message);
          }
        });
  };
};

const runDynamicQueryApi = (data, id, dq, page, reset, UUID) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  let result;
  if (reset === 'reset') {
    result = [];
  } else {
    if (UUID) {
      if (sessionStorage.getItem('SFDQ'))
        result = axios.post('dynamic-query?limit=0&request_id=' + UUID, data, {
          headers: headers,
        });
      else
        result = axios.post('dynamic-query?request_id=' + UUID, data, {
          headers: headers,
        });
    } else {
      if (sessionStorage.getItem('SFDQ'))
        result = axios.post('dynamic-query?limit=0', data, {
          headers: headers,
        });
      else result = axios.post('dynamic-query', data, { headers: headers });
    }
  }
  return result;
};

export const runDynamicQueryApiSuccess = (data) => {
  return {
    type: QUERY_RESULTS_FINAL_SUCCESS,
    data,
  };
};

export const downloadDynamicQuery = (data, type, email, page) => {
  return (dispatch) => {
    dispatch(fetchStart());
    downloadDynamicQueryAPI(data, type, email)
      .then((response) => {
        dispatch(fetchEnd());
        if (type == 'email') {
          globalToast.showSuccess(response.data.response);
        } else {
          toast(
            'Please wait.' + type == 'pdf'
              ? 'Pdf'
              : 'Sheet' + ' is getting downloaded.',
          );
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          let date = Date.now();
          link.setAttribute('download', date + '.xlsx'); //or any other extension
          document.body.appendChild(link);
          link.click();
        }
        if (page.includes('collaboration'))
          history.push('/collaboration-portal');
        else if (page.includes('partner')) history.push('/partner-statement');
        else history.push('/dynamic-query');
      })
      .catch((error) => {
        dispatch(fetchEnd());
        //globalToast.showError("Something went wrong. Please try again later.");
      });
  };
};
const downloadDynamicQueryAPI = (data, type, email) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  let result;
  if (type == 'email')
    result = axios.post(
      'download-dynamic-query-result?send_mail=true&&email_address=' + email,
      data,
      {
        headers: headers,
      },
    );
  else if (type == 'pdf')
    result = axios.post('/download-dynamic-query-result-pdf', data, {
      headers: headers,
      responseType: 'blob',
    });
  else
    result = axios.post('download-dynamic-query-result', data, {
      headers: headers,
      responseType: 'blob',
    });
  return result;
};
// Alert Management Repoting API
export const runAlertManagementReport = (data) => {
  return (dispatch) => {
    dispatch(fetchStart());
    runAlertManagementReportAPi(data)
      .then((response) => {
        dispatch(fetchEnd());
        if (response.data.response) {
          dispatch(fetchEnd());
          dispatch(alertManagementReportSuccess(response.data.response));
          history.push('/alert-management-report-result');
        } else {
          globalToast.showWarning('No records found.');
        }
      })
      .catch((error) => {
        dispatch(fetchEnd());
      });
  };
};

const runAlertManagementReportAPi = (data, UUID) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.post('execute-query', data, { headers: headers });
  return result;
};

const runExecuteQueryAPI = (data, UUID) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.post('execute-query', data, { headers: headers });
  return result;
};

const membershipTableAPI = (data) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  return axios.post('membership-table', data, { headers });
};

export const runExecuteQuery = (data) => {
  return async (dispatch) => {
    try {
      dispatch(fetchStart());   // own loading

      const response = await runExecuteQueryAPI(data);
      dispatch(executeQueryReportSuccess(response?.data?.response));
      return response;

    } catch (error) {
      throw error;

    } finally {
      dispatch(fetchEnd());     // own loading reset
    }
  };
};

export const clearExecuteQueryReport = () => {
  return {
    type: CLEAR_EXECUTE_REPORT,
  };
};

export const executeQueryReportSuccess = (data) => {
  return {
    type: EXECUTE_REPORT_SUCCESS,
    data,
  };
};
export const runMembershipTableQuery = (payload) => {
  return (dispatch) => {
    dispatch(fetchStart());
    return membershipTableAPI(payload)
      .then((response) => {
        dispatch(fetchEnd());
        const records = response?.data?.response?.records ?? response?.data?.records ?? [];
        const data = Array.isArray(records) ? records : [];
        dispatch({ type: MEMBERSHIP_TABLE_SUCCESS, data });
        return response;
      })
      .catch((error) => {
        dispatch(fetchEnd());
        dispatch({ type: MEMBERSHIP_TABLE_SUCCESS, data: [] });
        throw error;
      });
  };
};

export const alertManagementReportSuccess = (data) => {
  return {
    type: ALERT_MANAGEMENT_REPORT_SUCCESS,
    data,
  };
};


//Download and Upload Migration Management Data

export const downloadMigrationManagementData = (data) => {
  return (dispatch) => {
    dispatch(fetchStart());
    downloadMigrationManagementDataAPI(data)
      .then((response) => {
        dispatch(fetchEnd());
        // const contentDisposition = response.headers['content-disposition'];
        // const filename = contentDisposition ? contentDisposition.split('filename=')[1].split(';')[0] : `migration_data_${new Date().toISOString().split('T')[0]}.json`;
        const filename = `${data}_data.json`;
        // Convert the response data to JSON string
        const jsonData = JSON.stringify(response.data);
        toast('Please wait. The sheet is getting downloaded.');
        const url = window.URL.createObjectURL(
          new Blob([jsonData], { type: 'application/json' }),
        );
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', filename);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        history.push('/migration-management');
      })
      .catch((error) => {
        dispatch(fetchEnd());
        //globalToast.showError("Something went wrong. Please try again later.");
      });
  };
};
const downloadMigrationManagementDataAPI = (data) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  let result;
  result = axios.get('migration?table_names=' + data, {
    headers: headers,
  });
  return result;
};

export const uploadMigrationManagementData = (
  file,
  requester,
  selectedObjects,
) => {
  return (dispatch) => {
    dispatch(fetchStart());
    uploadMigrationManagementDataAPI(file, requester, selectedObjects)
      .then((response) => {
        dispatch(fetchEnd());
        globalToast.showSuccess('File have been successfully updated.');
      })
      .catch((error) => {
        dispatch(fetchEnd());
        globalToast.showError(ServerError);
      });
  };
};
const uploadMigrationManagementDataAPI = (file, requester, selectedObjects) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
    'Content-Type': 'multipart/form-data;',
  };
  // let result = axios.post("migration/upload?table_name=" + selectedObjects +
  //   "&organization_id=" + requester, file, {
  //   headers: headers,
  let result = axios.post('migration/upload', file, {
    headers: headers,
  });
  return result;
};

//run dynamic query
export const getDynamicQuery = (id) => {
  return (dispatch) => {
    dispatch(fetchStart());
    getDynamicQueryApi(id).then((response) => {
      dispatch(fetchEnd());
      dispatch(getDynamicQueryApiSuccess(response.data.response));
      // if (response.data && response.data.response && response.data.response.table_name &&
      //     response.data.response.table_name === 'sales_data') {
      //     dispatch(getDynamicQuerySalesDataFields());
      // } else if (response.data && response.data.response && response.data.response.table_name &&
      //     response.data.response.table_name === 'financial_postings') {
      //     dispatch(getDynamicQueryFields());
      // }
      // else if (response.data && response.data.response && response.data.response.table_name &&
      //     response.data.response.table_name === 'purchase_data') {
      //     dispatch(getPurchaseDataFields());
      // } else {
      //     dispatch(getCalculationSimulationDataFields());
      // }
    });
  };
};

const getDynamicQueryApi = (id) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  let result;
  result = axios.get('dynamic-query-format?format_id=' + id, {
    headers: headers,
  });
  return result;
};

export const deleteDynamicQuery = (id, pagination, limit, queryType, app) => {
  return (dispatch) => {
    dispatch(getQueryListApiSuccess({}));
    dispatch(fetchStart());
    deleteDynamicQueryAPI(id).then((response) => {
      dispatch(fetchEnd());
      dispatch(getQueryList(pagination, limit, queryType, app));
      globalToast.showSuccess('Query deleted successfully');
    });
  };
};

const deleteDynamicQueryAPI = (id) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  let result;
  result = axios.delete('dynamic-query-format?id=' + id, { headers: headers });
  return result;
};

export const cloneDynamicQuery = (id, pagination, limit, queryType, app) => {
  return (dispatch) => {
    dispatch(getQueryListApiSuccess({}));
    dispatch(fetchStart());
    cloneDynamicQueryAPI(id).then((response) => {
      dispatch(fetchEnd());
      globalToast.showSuccess('Query clonned successfully');
      dispatch(getQueryList(pagination, limit, queryType, app));
    });
  };
};

const cloneDynamicQueryAPI = (id) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  let result;
  result = axios.post('dynamic-query-format/clone/' + id, { headers: headers });
  return result;
};

export const getDynamicQueryApiSuccess = (data) => {
  return {
    type: DYNAMIC_QUERY_DETAILS_SUCCESS,
    data,
  };
};

//get claims format fields
export const getClaimsFormatFields = () => {
  return (dispatch) => {
    getClaimsFormatFieldsAPI().then((response) => {
      dispatch(getClaimsFormatFieldsSuccess(response.data.response));
    });
  };
};

const getClaimsFormatFieldsAPI = () => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  let result;
  result = axios.get('claim-format-fields', { headers: headers });
  return result;
};

export const getClaimsFormatFieldsSuccess = (data) => {
  sessionStorage.setItem('dq_table_name', data.table_name);
  return {
    type: CLAIMS_FORMAT_FIELDS_SUCCESS,
    data,
  };
};

export const getIncomingClaimsQuery = (id) => {
  return (dispatch) => {
    getIncomingClaimsQueryAPI(id).then((response) => {
      dispatch(getIncomingClaimsQuerySuccess(response.data.response));
      if (
        response.data &&
        response.data.response &&
        response.data.response.table_name &&
        response.data.response.table_name === 'sales_data'
      ) {
        dispatch(getDynamicQuerySalesDataFields());
      } else {
        dispatch(getDynamicQueryFields());
      }
    });
  };
};

const getIncomingClaimsQueryAPI = (id) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  let result;
  result = axios.get(
    '/upload-format' + id + '?app-functionality=IndirectSalesDataFormat',
    { headers: headers },
  );
  return result;
};

export const getIncomingClaimsQuerySuccess = (data) => {
  return {
    type: INCOMING_CLAIM_DETAILS_SUCCESS,
    data,
  };
};

export const loadTargetData = () => {
  return (dispatch) => {
    loadTargetDataAPI().then((response) => {
      dispatch(loadTargetDataAPISuccess(response.data.response));
    });
  };
};

const loadTargetDataAPI = () => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  let result;
  result = axios.get('target-data-fetch-all', { headers: headers });
  return result;
};

export const loadTargetDataAPISuccess = (data) => {
  return {
    type: LOAD_TARGET_DATA,
    data,
  };
};

export const customerAndSupplierCollaborationPortal = () => {
  return (dispatch) => {
    customerAndSupplierCollaborationPortalAPI()
      .then((response) => {
        dispatch(
          customerAndSupplierCollaborationPortalSuccess(response.data.response),
        );
      })
      .catch((error) => {
        if (
          error &&
          error.response &&
          error.response.data &&
          error.response.data.error &&
          error.response.data.error.message
        ) {
          //globalToast.showError(error.response.data.error.message);
        }
      });
  };
};

const customerAndSupplierCollaborationPortalAPI = () => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  let result;
  result = axios.get('collaboration-portal-attrs', { headers: headers });
  return result;
};

export const customerAndSupplierCollaborationPortalSuccess = (data) => {
  return {
    type: COLL_PORTAL_CUST_SUPP,
    data,
  };
};

export const getOutgoingClaimsFormatFields = () => {
  return (dispatch) => {
    getOutgoingClaimsFormatFieldsAPI().then((response) => {
      dispatch(getOutgoingClaimsFormatFieldsSuccess(response.data.response));
    });
  };
};

const getOutgoingClaimsFormatFieldsAPI = () => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  let result;
  result = axios.get('claim-response-fields', { headers: headers });
  return result;
};

export const getOutgoingClaimsFormatFieldsSuccess = (data) => {
  return {
    type: OUTGOING_CLAIMS_FORMAT_FIELDS_SUCCESS,
    data,
  };
};

export const getOutgoingClaimsQuery = (id) => {
  return (dispatch) => {
    getOutgoingClaimsQueryAPI(id).then((response) => {
      dispatch(getOutgoingClaimsQuerySuccess(response.data.response));
    });
  };
};

const getOutgoingClaimsQueryAPI = (id) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  let result;
  result = axios.get('claim-response-format?format_id=' + id, {
    headers: headers,
  });
  return result;
};

export const getOutgoingClaimsQuerySuccess = (data) => {
  return {
    type: OUTGOING_CLAIM_DETAILS_SUCCESS,
    data,
  };
};

export const getDynamicQueryFieldsNew = (appType, tableName, loading) => {
  return (dispatch) => {
    dispatch(fetchStart());
    getDynamicQueryFieldsNewApi(appType, tableName, loading).then(
      (response) => {
        if (loading !== 'No') {
          dispatch(fetchEnd());
        }
        dispatch(getDynamicQueryFieldsNewApiSuccess(response.data.response));
      },
    );
  };
};

const getDynamicQueryFieldsNewApi = (appType, tableName) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  let result;
  result = axios.get(
    'dynamic-query-fields?app_type=' +
    appType +
    '&table_description=' +
    tableName,
    { headers: headers },
  );
  return result;
};

export const getDynamicQueryFieldsNewApiSuccess = (data) => {
  return {
    type: DYNAMIC_QUERY_FIELDS_SUCCESS_NEW,
    data,
  };
};

export const getAllOrganizationUsers = () => {
  return (dispatch) => {
    getAllOrganizationUsersAPI()
      .then((response) => {
        if (response.data && response.data.response)
          dispatch(getAllOrgUser(response.data.response));
      })
      .catch((error) => { });
  };
};

const getAllOrganizationUsersAPI = () => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  let result = axios.get('org-users', { headers: headers });
  return result;
};

export const getAllOrgUser = (data) => {
  return {
    type: GET_ALL_ORG_USERS,
    data,
  };
};

export const getTableDeterminationData = (applicationType) => {
  return (dispatch) => {
    dispatch(fetchStart());
    getTableDeterminationDataAPI(applicationType).then((response) => {
      dispatch(fetchEnd());
      dispatch(getTableDeterminationDataAPISuccess(response.data.response));
    });
  };
};

const getTableDeterminationDataAPI = (applicationType) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  let result;
  if (applicationType) {
    result = axios.get(
      'dynamic-query-table-determination?application_type=' + applicationType,
      { headers: headers },
    );
  } else {
    result = axios.get('dynamic-query-table-determination', {
      headers: headers,
    });
  }
  return result;
};

export const getTableDeterminationDataAPISuccess = (data) => {
  return {
    type: TABLE_DETERMINATION_SUCCESS,
    data,
  };
};

//run predefinedQuery
export const runPredefinedQuery = (data, id, uuid, options = {}) => {
  return (dispatch) => {
    dispatch(fetchStart());
    runPredefinedQueryApi(data, id, uuid)
      .then((response) => {
        dispatch(fetchEnd());
        //if (reset != 'reset') {
        if (response.data.response && response.data.response.length === 0) {
          globalToast.showWarning('No records found');
        } else if (
          response.data.response &&
          response.data.response.length > 0
        ) {
          dispatch(runPredefinedQueryApiSuccess(response.data.response));

          // If a callback is provided, call it with the response data
          // This allows components to handle the data without navigation
          if (options.onSuccess && typeof options.onSuccess === 'function') {
            options.onSuccess(response.data.response);
          } else {
            // Only navigate if no callback is provided
            history.push(
              '/predefined-query/predefined-query-form/results/' + id,
            );
          }
        }
      })
      .catch((error) => {
        dispatch(fetchEnd());
        if (
          error &&
          error.response &&
          error.response.data &&
          error.response.data.complete_error_message
        ) {
          //globalToast.showError(error.response.data.complete_error_message);
        }

        // Call error callback if provided
        if (options.onError && typeof options.onError === 'function') {
          options.onError(error);
        }
      });
  };
};

const runPredefinedQueryApi = (data, id, uuid) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  let result;
  // if (reset === 'reset') {
  //     result = [];
  // } else {
  result = axios.post(
    'run-sql-work-bench/' + id + '?request_id=' + uuid,
    data,
    { headers: headers },
  );

  return result;
};

export const runPredefinedQueryApiSuccess = (data) => {
  return {
    type: PREDEFINED_QUERY_RESULTS_FINAL_SUCCESS,
    data,
  };
};

export const getQueryasListSuccess = (data) => {
  return {
    type: QUERY_LIST_SUCCESS,
    data,
  };
};

export const clearQueryList = () => {
  return {
    type: QUERY_LIST_CLEAR,
  };
};

export const getQueryasList = (pagination, limit) => {
  return (dispatch) => {
    // Dispatch loading start action
    dispatch({ type: 'FETCH_START' });

    getQueryasListAPI(pagination, limit)
      .then((response) => {
        dispatch(getQueryasListSuccess(response.data.response));
        // Dispatch loading end action
        dispatch({ type: 'FETCH_END' });
      })
      .catch((error) => {
        console.error('Error fetching query list:', error);
        // Dispatch error action
        dispatch({
          type: 'FETCH_END',
          error: error.response?.data?.message || 'Failed to fetch query list',
        });
      });
  };
};

const getQueryasListAPI = (pagination, limit) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  let result;
  result = axios.get(
    'sql-work-bench?page=' +
    pagination +
    '&limit=' +
    limit +
    '&application_type=' +
    sessionStorage.getItem('application'),
    { headers: headers },
  );
  return result;
};

export const getExcelPredefinedFileDownlaod = (data, id, type) => {
  return (dispatch) => {
    dispatch(fetchStart());
    getExcelPredefinedFileDownlaodApi(data, id, type)
      .then((response) => {
        dispatch(fetchEnd());
        if (type === 'Email') {
          globalToast.showSuccess(response.data.response);
        } else {
          toast('Please wait. File is getting downloaded.');
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          let [data, data2] = response.headers['content-type'].split(';');
          link.setAttribute('download', data2.trim());
          document.body.appendChild(link);
          link.click();
        }
      })
      .catch((error) => {
        dispatch(fetchEnd());
      });
  };
};

const getExcelPredefinedFileDownlaodApi = (data, id, type) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  let result;
  if (type === 'Email') {
    result = axios.post(
      'download-sql-work-bench-result/' + id + '?send_mail=true',
      data,
      { headers: headers },
    );
  } else {
    result = axios.post('download-sql-work-bench-result/' + id, data, {
      headers: headers,
      responseType: 'blob',
    });
  }
  return result;
};

//run dynamic query
export const getPredefinedQuery = (id) => {
  return (dispatch) => {
    getPredefinedQueryApi(id).then((response) => {
      dispatch(getPredefinedQueryApiSuccess(response.data.response));
      // if (response.data && response.data.response && response.data.response.table_name &&
      //     response.data.response.table_name === 'sales_data') {
      //     dispatch(getDynamicQuerySalesDataFields());
      // } else if (response.data && response.data.response && response.data.response.table_name &&
      //     response.data.response.table_name === 'financial_postings') {
      //     dispatch(getDynamicQueryFields());
      // }
      // else if (response.data && response.data.response && response.data.response.table_name &&
      //     response.data.response.table_name === 'purchase_data') {
      //     dispatch(getPurchaseDataFields());
      // } else {
      //     dispatch(getCalculationSimulationDataFields());
      // }
    });
  };
};

const getPredefinedQueryApi = (id) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  let result;
  result = axios.get('sql-work-bench', { headers: headers });
  return result;
};

export const getPredefinedQueryApiSuccess = (data) => {
  return {
    type: PREDEFINED_QUERY_DETAILS_SUCCESS,
    data,
  };
};

export const downloadPredefinedQuery = (data) => {
  return (dispatch) => {
    downloadPredefinedQueryAPI(data)
      .then((response) => {
        toast('Please wait. Sheet is getting downloaded.');
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        let date = Date.now();
        link.setAttribute('download', date + '.xlsx'); //or any other extension
        document.body.appendChild(link);
        link.click();
      })
      .catch((error) => {
        //globalToast.showError("Something went wrong. Please try again later.");
      });
  };
};
const downloadPredefinedQueryAPI = (data) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  let result;
  result = axios.get('run-sql-work-bench', {
    params: data,
    headers: headers,
    responseType: 'blob',
  });
  return result;
};
//query ref

export const getQueryRefData = (id, type, data, functionality, multiple) => {
  return (dispatch) => {
    getQueryRefDataAPI(id, type, data, functionality).then((response) => {
      if (type == 'batchjobsetup_filters' || multiple)
        dispatch(
          getQueryRefDataAPISuccess(
            { [functionality]: response.data.response?.records || [] },
            type,
          ),
        );
      else dispatch(getQueryRefDataAPISuccess(response.data.response, type));
      if (type == 'create' || type == 'edit') getQueryRefData(id);
    });
  };
};

const getQueryRefDataAPI = (id, type, data, functionality) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  let result;
  if (type == 'create')
    result = axios.post(
      'dynamic-query-filter?functionality=' + functionality,
      data,
      { headers: headers },
    );
  else if (type == 'edit')
    result = axios.put(
      'dynamic-query-filter?functionality=' + functionality,
      data,
      { headers: headers },
    );
  else if (type == 'deleteAll')
    result = axios.delete('dynamic-query-filter?query_id=' + encodeURIComponent(id), {
      headers: headers,
    });
  else if (type == 'deleteAll')
    result = axios.delete('dynamic-query-filter?id=' + encodeURIComponent(id), {
      headers: headers,
    });
  else
    result = axios.get('dynamic-query-filter?query_id=' + encodeURIComponent(id), {
      headers: headers,
    });
  return result;
};

export const getQueryRefDataAPISuccess = (data, type) => {
  if (type == 'datagrid')
    return {
      type: CUSTOM_VIEW,
      data,
    };
  if (type == 'batchjobsetup_filters')
    // for fetching filters used in batchjob creation
    return {
      type: BATCH_JOB_FILTERS,
      data,
    };
  else
    return {
      type: DYNAMIC_QUERY_FILTER,
      data,
    };
};
export const getFilterValues = (param, filterConfigId) => {
  return async (dispatch) => {
    dispatch(fetchStart());
    try {
      const response = await getFilterValuesAPI(param);
      //console.log(" [Thunk] API raw response:", response);
      if (response?.data?.response) {
        //console.log(" [Thunk] response.data.response:", response.data.response);
        dispatch(fetchEnd());
        if (filterConfigId)
          dispatch(getFilterValuesSuccess({ [filterConfigId]: response.data.response || [] }));
        else
          dispatch(getFilterValuesSuccess(response.data.response));
      } else {
        dispatch(fetchEnd());
        console.warn('No filter values received for:', param?.filter_group);
      }
    } catch (error) {
      dispatch(fetchEnd());
      console.error('Error fetching filter values:', error);
    }
  };
};

export const getFilterValuesAPI = (param) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };

  return axios.get(`/filter-values`, { params: param, headers });
};

export const getFilterValuesSuccess = (data) => {
  //console.log(" [Action Creator] getFilterValuesSuccess called with data:", data);
  return {
    type: 'GET_FILTER_VALUES_SUCCESS',
    data,
  };
};
export const getFilterValuesById = (id) => {
  if (typeof id !== 'string' && typeof id !== 'number') {
    //console.error('Invalid ID type provided to getFilterValuesById:', typeof id);
    return () => { }; // Return empty function to prevent further errors
  }

  // Convert to string and validate it's a proper ID
  const idStr = String(id).trim();
  if (!idStr) {
    console.error('Empty ID provided to getFilterValuesById');
    return () => { };
  }

  return async (dispatch) => {
    dispatch(fetchStart());
    try {
      const response = await getFilterValuesByIdAPI(idStr);
      if (response?.data?.response) {
        dispatch(fetchEnd());
        dispatch(getFilterValuesByIdSuccess(response.data.response));
      } else {
        dispatch(fetchEnd());
        console.warn('No response data received for filter values ID:', idStr);
      }
    } catch (error) {
      dispatch(fetchEnd());
      console.error('Error fetching filter values:', error);
    }
  };
};

const getFilterValuesByIdAPI = (id) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  return axios.get(`/filter-values?id=${id}`, { headers });
};

export const getFilterValuesByIdSuccess = (data) => {
  return {
    type: FILTER_VALUES_BY_ID,
    data,
  };
};
export const getQueryRefById = (id) => {
  // Ensure id is a valid value and not a function or object
  if (typeof id !== 'string' && typeof id !== 'number') {
    console.error('Invalid ID type provided to getQueryRefById:', typeof id);
    return () => { }; // Return empty function to prevent further errors
  }

  // Convert to string and validate it's a proper ID
  const idStr = String(id).trim();
  if (!idStr) {
    console.error('Empty ID provided to getQueryRefById');
    return () => { };
  }

  return async (dispatch) => {
    dispatch(fetchStart());
    try {
      const response = await getQueryRefByIdAPI(idStr);
      if (response?.data?.response) {
        dispatch(fetchEnd());
        dispatch(getQueryRefByIdAPISuccess(response.data.response));
      } else {
        dispatch(fetchEnd());
        console.warn('No response data received for query ID:', idStr);
      }
    } catch (error) {
      dispatch(fetchEnd());
      console.error('Error fetching query reference:', error);
    }
  };
};

export const getGlobalGridView = (gridId, viewName) => {
  if ((typeof gridId !== 'string' && typeof gridId !== 'number') || typeof viewName !== 'string') {
    console.error('Invalid input provided to getGlobalGridView');
    return async () => ({ applied: false });
  }

  const gridIdStr = String(gridId).trim();
  const viewNameStr = String(viewName).trim();
  if (!gridIdStr || !viewNameStr) {
    console.error('Empty gridId or viewName provided to getGlobalGridView');
    return async () => ({ applied: false });
  }

  return async (dispatch) => {
    dispatch(fetchStart());
    try {
      const response = await getGlobalGridViewAPI(gridIdStr, viewNameStr);
      const record = response?.data?.response;
      // Backend returns { ID: 0, filter_name: "" } when no view exists — treat as not found
      const viewExists = record?.filter_name && record.filter_name.trim() !== '' && record?.ID && record.ID !== 0;
      if (viewExists) {
        dispatch(fetchEnd());
        dispatch(getQueryRefByIdAPISuccess(record));
        return { applied: true, data: record };
      } else {
        dispatch(fetchEnd());
        return { applied: false };
      }
    } catch (error) {
      dispatch(fetchEnd());
      console.error('Error fetching global grid view:', error);
      return { applied: false };
    }
  };
};

const getGlobalGridViewAPI = (gridId, viewName) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  let result;
  result = axios.get(`global-grid-view?grid_id=${encodeURIComponent(gridId)}&view_name=${encodeURIComponent(viewName)}`, { headers: headers });
  return result;
};

const getQueryRefByIdAPI = (id) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  let result;
  result = axios.get('dynamic-query-filter/' + id, { headers: headers });
  return result;
};

export const getQueryRefByIdAPISuccess = (data) => {
  return {
    type: DYNAMIC_QUERY_FILTER_BY_ID,
    data,
  };
};
export const updateQueryRefData = (
  type,
  data,
  id,
  page,
  table,
  report,
  Query,
  loaders,
) => {
  return (dispatch) => {
    if (type == 'create' || type == 'edit') dispatch(fetchStart());
    updateQueryRefDataAPI(type, data, id, report, Query, loaders)
      .then((response) => {
        globalToast.showSuccess(response.data.response);
        if (type == 'create' || type == 'edit') {
          dispatch(runDynamicQueryApiSuccess(response.data.response));
          dispatch(getQueryRefData(data.query_id));
          if (loaders !== 'No_Loader') {
            dispatch(fetchEnd());
          }
          if (page != 'filter-page' && page != 'PredefineQueryR') {
            let id_1 = data && data.query_id ? data.query_id : '';
            if (page.includes('collaboration'))
              history.push(
                '/collaboration-portal/collaboration-portal-form/results/' +
                id_1,
              );
            else if (page.includes('partner')) {
              history.push(
                '/partner-statement/partner-statement-form/results/' + id_1,
              );
            } else {
              if (!sessionStorage.getItem('SFDQ')) {
                history.push(
                  '/dynamic-query/dynamic-query-form/results/' + id_1,
                );
              } else {
                if (Query != 'OnDemand')
                  history.push(
                    '/dynamic-query/dynamic-query-form-sf/results/' + id_1,
                  );
              }
            }
          }
        }
        if (type == 'delete') {
          dispatch(getQueryRefData(data));
        }
      })
      .catch((error) => {
        dispatch(fetchEnd());
      });
  };
};

const updateQueryRefDataAPI = (type, data, id, report, Query) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  let result;
  if (Query === 'OnDemand') {
    if (type == 'create')
      if (report) {
        result = axios.post(
          'dynamic-query-filter?functionality=opeational_reports',
          data,
          { headers: headers },
        );
      } else {
        result = axios.post(
          'dynamic-query-filter?functionality=dynamic_query',
          data,
          { headers: headers },
        );
      }
    else if (type == 'edit')
      if (report) {
        result = axios.put(
          'dynamic-query-filter?functionality=opeational_reports',
          data,
          { headers: headers },
        );
      } else {
        result = axios.put(
          'dynamic-query-filter?functionality=dynamic_query',
          data,
          { headers: headers },
        );
      }
    else if (type == 'deleteAll')
      result = axios.delete('dynamic-query-filter?query_id=' + id, {
        headers: headers,
      });
    else
      result = axios.delete('dynamic-query-filter?id=' + id, {
        headers: headers,
      });
  } else {
    if (type == 'create')
      if (report) {
        result = axios.post(
          'dynamic-query-filter?functionality=opeational_reports',
          data,
          { headers: headers },
        );
      } else {
        result = axios.post('dynamic-query-filter', data, { headers: headers });
      }
    else if (type == 'edit')
      if (report) {
        result = axios.put(
          'dynamic-query-filter?functionality=opeational_reports',
          data,
          { headers: headers },
        );
      } else {
        result = axios.put('dynamic-query-filter', data, { headers: headers });
      }
    else if (type == 'deleteAll')
      result = axios.delete('dynamic-query-filter?query_id=' + id, {
        headers: headers,
      });
    else
      result = axios.delete('dynamic-query-filter?id=' + id, {
        headers: headers,
      });
  }

  return result;
};
export const updateFilterValues = (type, data, pageID, loaders) => {
  return (dispatch) => {
    dispatch(fetchStart());

    const headers = {
      Authorization: secureLocalStorage.getItem('aTk'),
    };

    let request;
    if (type === 'delete') {
      const id = data.ID;
      request = axios.delete(`/filter-values/${id}`, { headers });
    } else {
      request = axios.post('/filter-values', data, { headers });
    }

    return request
      .then((response) => {
        if (type === 'delete') {
          globalToast.showSuccess(`Filter '${data.filter_name}' deleted successfully.`);
        } else {

          globalToast.showSuccess(response.data.message);
          dispatch(runDynamicFilterApiSuccess(response.data.response));
        }
        dispatch(getFilterValues(pageID));

        if (loaders !== 'No_Loader') dispatch(fetchEnd());
        return response;
      })
      .catch((error) => {
        globalToast.showError(error?.response?.data?.message || 'Something went wrong');
        dispatch(fetchEnd());
        throw error;
      });
  };
};


export const runDynamicFilterApiSuccess = (data) => {
  return {
    type: DYNAMIC_FILTER_API_SUCCESS,
    data,
  };
};
export const reconcileIntegration = (id, data) => {
  return (dispatch) => {
    dispatch(fetchStart());

    return reconcileIntegrationApi(id, data)
      .then((response) => {
        globalToast.showSuccess(
          response?.data?.response || 'Reconciliation successful'
        );

        dispatch(
          reconcileIntegrationSuccess(response.data.response)
        );

        dispatch(fetchEnd());
        return response;
      })
      .catch((error) => {
        dispatch(fetchEnd());
        throw error;
      });
  };
};
const reconcileIntegrationApi = (id, data) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };

  return axios.post(
    `/integration/reconciliation/${id}`,
    data,
    { headers }
  );
};
export const reconcileIntegrationSuccess = (data) => {
  return {
    type: RECONCILE_INTEGRATION_SUCCESS,
    data,
  };
};
export const updateQueryRefDataMaster = (type, data, id, page, loaders) => {
  return (dispatch) => {
    if (type == 'create' || type == 'edit') dispatch(fetchStart());
    return updateQueryRefDataMasterAPI(type, data, id, page, loaders)
      .then((response) => {
        if (type == 'create' || type == 'edit') {
          globalToast.showSuccess(response.data.response);
        }
        if (type == 'create' || type == 'edit') {
          dispatch(runDynamicQueryApiSuccess(response.data.response));
          // dispatch(fetchEnd());
          if (loaders !== 'No_Loader') {
            dispatch(fetchEnd());
          }
        }
        if (type == 'delete') {
          globalToast.showSuccess(response.data.response);
          dispatch(getQueryRefData(data));
        }
        return response; // Return response so component can handle toast
      })
      .catch((error) => {
        dispatch(fetchEnd());
        return Promise.reject(error);
      });
  };
};

const updateQueryRefDataMasterAPI = (type, data, id, page, loaders) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  let result;

  if (page == 'document_header') {
    if (type == 'create')
      result = axios.post(
        'dynamic-query-filter?functionality=document_header',
        data,
        { headers: headers },
      );
    else if (type == 'edit')
      result = axios.put(
        'dynamic-query-filter?functionality=document_header',
        data,
        { headers: headers },
      );
    else if (type == 'deleteAll')
      result = axios.delete('dynamic-query-filter?query_id=' + id, {
        headers: headers,
      });
    else
      result = axios.delete('dynamic-query-filter?id=' + id, {
        headers: headers,
      });
  } else if (page == 'contract_header') {
    if (type == 'create')
      result = axios.post(
        'dynamic-query-filter?functionality=contract_header',
        data,
        { headers: headers },
      );
    else if (type == 'edit')
      result = axios.put(
        'dynamic-query-filter?functionality=contract_header',
        data,
        { headers: headers },
      );
    else if (type == 'deleteAll')
      result = axios.delete('dynamic-query-filter?query_id=' + id, {
        headers: headers,
      });
    else
      result = axios.delete('dynamic-query-filter?id=' + id, {
        headers: headers,
      });
  } else if (page === 'Promotion Planning') {
    if (type == 'create')
      result = axios.post(
        'dynamic-query-filter?functionality=promotions',
        data,
        { headers: headers },
      );
    else if (type == 'edit')
      result = axios.put(
        'dynamic-query-filter?functionality=promotions',
        data,
        { headers: headers },
      );
    else if (type == 'deleteAll')
      result = axios.delete('dynamic-query-filter?query_id=' + id, {
        headers: headers,
      });
    else
      result = axios.delete('dynamic-query-filter?id=' + id, {
        headers: headers,
      });
  } else if (page === 'Build Sales Data') {
    if (type == 'create')
      result = axios.post(
        'dynamic-query-filter?functionality=Batch Job',
        data,
        { headers: headers },
      );
    else if (type == 'edit')
      result = axios.put('dynamic-query-filter?functionality=Batch Job', data, {
        headers: headers,
      });
    else if (type == 'deleteAll')
      result = axios.delete('dynamic-query-filter?query_id=' + id, {
        headers: headers,
      });
    else
      result = axios.delete('dynamic-query-filter?id=' + id, {
        headers: headers,
      });
  } else {
    if (type == 'create')
      result = axios.post(
        'dynamic-query-filter?functionality=master_data',
        data,
        { headers: headers },
      );
    else if (type == 'edit')
      result = axios.put(
        'dynamic-query-filter?functionality=master_data',
        data,
        { headers: headers },
      );
    else if (type == 'deleteAll')
      result = axios.delete('dynamic-query-filter?query_id=' + id, {
        headers: headers,
      });
    else
      result = axios.delete('dynamic-query-filter?id=' + id, {
        headers: headers,
      });
  }

  return result;
};
const getCollaborationByIdAPI = (id) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };

  return axios.get(`/collaborations/${id}`, { headers });
};
export const getCollaborationById = (id) => {
  return (dispatch) => {
    return getCollaborationByIdAPI(id)
      .then((response) => {
        dispatch(getCollaborationByIdSuccess(response.data.response));
        return response.data.response;
      })
      .catch((error) => {
        console.error('Error getting collaboration by ID:', error);
        throw error;
      });
  };
};
const getCollaborationByIdSuccess = (data) => {
  return {
    type: GET_COLLABORATION_BY_ID_SUCCESS,
    data,
  };
};
export const addMaterialDesign = (data, type) => {
  return (dispatch) => {
    return addMaterialDesignAPI(data, type)
      .then((response) => {
        //console.log("response", response);
        // Check if response has a status code of 400 but still contains data
        if (response.data && response.data.status === 400) {
          // If there are failed items, show specific errors
          if (
            response.data.response &&
            response.data.response.failed &&
            response.data.response.failed.length > 0
          ) {
            response.data.response.failed.forEach((item) => {
              const errorMessage = `${item.view || ''}: ${item.error}`;
              globalToast.showError(errorMessage);
            });

            // Show the main error message if available
            if (response.data.message) {
              globalToast.showError(response.data.message);
            }

            return { success: false, error: response.data.response };
          }

          // If no specific failed items, show the general message
          if (response.data.message) {
            globalToast.showError(response.data.message);
          } else {
            globalToast.showError(
              'Failed to save configuration. Please check your inputs.',
            );
          }

          return { success: false, error: response.data };
        }

        // Handle successful response
        const successMessages = response.data.message;
        if (Array.isArray(successMessages)) {
          successMessages.forEach((msg) => {
            if (msg.message_type === 'success') {
              globalToast.showSuccess(msg.message);
            }
          });
        } else {
          // Fallback message
          globalToast.showSuccess(
            type === 'supplier'
              ? 'Supplier Design Added Successfully'
              : type === 'customer'
                ? 'Customer Design Added Successfully'
                : 'Material Design Added Successfully',
          );
        }

        if (type === 'supplier') {
          dispatch(addMaterialDesignSuccess(response.data.response));
        }
        return { success: true, response };
      })
      .catch((error) => {
        //console.log('API Error:', error);

        // Check for error response with data
        if (error.response && error.response.data) {
          const responseData = error.response.data;
          //console.log('responseData', responseData);

          // Check if there's a message in the error response
          if (responseData.message) {
            globalToast.showError(responseData.message);
          }

          // Check if there are failed items
          if (
            responseData.response &&
            responseData.response.failed &&
            responseData.response.failed.length > 0
          ) {
            // Display each failed item error
            responseData.response.failed.forEach((item) => {
              const errorMessage = `${item.view || ''}: ${item.error}`;
              globalToast.showError(errorMessage);
            });

            return { success: false, error: responseData.response };
          }
        }

        // Generic error if no specific errors found
        globalToast.showError('Failed to save configuration. Please try again.');
        return { success: false, error };
      });
  };
};

const addMaterialDesignSuccess = (data) => {
  return {
    type: ADD_MATERIAL_DESIGN_SUCCESS,
    data,
  };
};
export const executeFilterValues = (data) => {
  return (dispatch) => {
    return executeFilterValuesAPI(data)
      .then((response) => {
        dispatch(executeFilterValuesSuccess(response.data));

        // if (response.data?.message) {
        //   globalToast.showSuccess(response.data.message);
        // }

        return response.data;
      })
      .catch((error) => {
        console.error('Error executing filters:', error);

        const errMessage =
          error?.response?.data?.message ||
          'Failed to execute filters';

        // globalToast.showError(errMessage);
        throw error;
      });
  };
};
const executeFilterValuesAPI = (data) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };

  return axios.post('/filter-values/execute', data, {
    headers,
  });
};
export const executeFilterValuesSuccess = (data) => {
  return {
    type: EXECUTE_FILTER_VALUES_SUCCESS,
    data,
  };
};
// Action creator for successful supplier profile copy
const copySupplierProfileSuccess = (data) => {
  return {
    type: COPY_SUPPLIER_PROFILE_SUCCESS,
    data,
  };
};

// Action creator for failed supplier profile copy
const copySupplierProfileFail = (error) => {
  return {
    type: COPY_SUPPLIER_PROFILE_FAIL,
    error,
  };
};

// Copy supplier profile API handler
export const copySupplierProfile = (data, callback) => {
  return (dispatch) => {
    return axios
      .post('/supplier-master-design/copy-profile', data)
      .then((response) => {
        // Handle 400 errors that might come with a 200 status
        if (response.data && response.data.status === 400) {
          // If there are failed items, show specific errors
          if (
            response.data.response &&
            response.data.response.failed &&
            response.data.response.failed.length > 0
          ) {
            response.data.response.failed.forEach((item) => {
              const errorMessage = `${item.view || ''}: ${item.error}`;
              globalToast.showError(errorMessage);
            });
          } else {
            // If no specific failed items, show the general message
            if (response.data.message) {
              globalToast.showError(response.data.message);
            } else {
              globalToast.showError(
                'Failed to copy supplier profile. Please check your inputs.',
              );
            }
          }

          dispatch(copySupplierProfileFail(response.data));
          return { success: false, error: response.data };
        }

        // Handle successful response
        globalToast.showSuccess('Supplier Profile Copied Successfully');
        dispatch(copySupplierProfileSuccess(response.data.response));

        if (callback) {
          callback();
        }

        return { success: true, response };
      })
      .catch((error) => {
        //console.log('API Error:', error);

        // Check for error response with data
        if (error.response && error.response.data) {
          const responseData = error.response.data;
          //console.log('responseData', responseData);

          // Check if there's a message in the error response
          if (responseData.message) {
            globalToast.showError(responseData.message);
          }

          // Check if there are failed items
          if (
            responseData.response &&
            responseData.response.failed &&
            responseData.response.failed.length > 0
          ) {
            // Display each failed item error
            responseData.response.failed.forEach((item) => {
              const errorMessage = `${item.view || ''}: ${item.error}`;
              globalToast.showError(errorMessage);
            });

            dispatch(copySupplierProfileFail(responseData.response));
            return { success: false, error: responseData.response };
          }
        }

        // Generic error if no specific errors found
        globalToast.showError('Failed to copy supplier profile. Please try again.');
        dispatch(copySupplierProfileFail(error));
        return { success: false, error };
      });
  };
};

// Action creator for successful set default supplier profile
const setSupplierProfileDefaultSuccess = (data) => {
  return {
    type: SET_SUPPLIER_PROFILE_DEFAULT_SUCCESS,
    data,
  };
};

// Action creator for failed set default supplier profile
const setSupplierProfileDefaultFail = (error) => {
  return {
    type: SET_SUPPLIER_PROFILE_DEFAULT_FAIL,
    error,
  };
};
// result = axios.post('mdm/supplier-master-design', data, {
//   headers: headers,
// });
// Set supplier profile as default API handler

// Helper function to format validation errors in a creative way
const formatValidationErrors = (failedItems) => {
  if (!failedItems || failedItems.length === 0) {
    return null;
  }

  // Group errors by type for better visualization
  const errorsByType = failedItems.reduce((acc, item) => {
    const errorType = item.error || 'Unknown Error';
    if (!acc[errorType]) {
      acc[errorType] = [];
    }
    acc[errorType].push(item.attribute);
    return acc;
  }, {});

  // Create visually appealing error messages
  return Object.entries(errorsByType).map(([errorType, attributes]) => {
    return {
      type: errorType,
      attributes,
      message: `${errorType}: ${attributes.join(', ')}`,
      icon: getErrorIcon(errorType),
      severity: 'error',
      suggestion: getErrorSuggestion(errorType),
    };
  });
};

// Get appropriate icon based on error type
const getErrorIcon = (errorType) => {
  const errorIcons = {
    'profile is required': '📋',
    'is required': '⚠️',
    'invalid format': '🔍',
    'already exists': '🔄',
    'not found': '🔎',
    default: '❌',
  };

  // Find the matching error pattern
  const matchedPattern = Object.keys(errorIcons).find((pattern) =>
    errorType.toLowerCase().includes(pattern.toLowerCase()),
  );

  return matchedPattern ? errorIcons[matchedPattern] : errorIcons.default;
};

// Get helpful suggestion based on error type
const getErrorSuggestion = (errorType) => {
  if (errorType.toLowerCase().includes('profile is required')) {
    return 'Please select a profile for this attribute';
  } else if (errorType.toLowerCase().includes('is required')) {
    return 'This field cannot be empty';
  } else if (errorType.toLowerCase().includes('invalid format')) {
    return 'Please check the format of this field';
  } else if (errorType.toLowerCase().includes('already exists')) {
    return 'This value is already in use';
  } else if (errorType.toLowerCase().includes('not found')) {
    return 'The referenced item could not be found';
  }
  return 'Please review this field';
};

const addMaterialDesignAPI = (data, type) => {
  //console.log('addMaterialDesignAPI called with data:', data);
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  let result;
  if (type === 'supplier') {
    result = axios.post('mdm/supplier-master-design', data, { headers });
  } else if (type === 'customer') {
    result = axios.post('mdm/customer-master-design', data, { headers });
  } else if (type === 'employee') {
    result = axios.post('mdm/employee-master-design', data, { headers });
  } else {
    result = axios.post('mdm/material-master-design', data, { headers });
  }
  return result;
};

export const viewMaterialDesign = (id) => {
  return (dispatch) => {
    //console.log('viewMaterialDesign action called with id:', id);
    return viewMaterialDesignAPI(id)
      .then((response) => {
        // console.log('viewMaterialDesign API response:', response);
        // console.log('viewMaterialDesign data to dispatch:', response.data.response);
        dispatch(viewMaterialDesignSuccess(response.data.response));
        return response.data.response;
      })
      .catch((error) => {
        console.error('Error viewing material design:', error);
        throw error;
      });
  };
};

const viewMaterialDesignAPI = (id) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  return axios.get(`mdm/material-master-design/${id}`, { headers: headers });
};

export const viewMaterialDesignSuccess = (data) => {
  return {
    type: VIEW_MATERIAL_DESIGN_SUCCESS,
    data,
  };
};

// Delete Material Master Design Data
// export const deleteMaterialDesign = (row, type = 'material') => (dispatch) => {
//   // console.log('deleteMaterialDesign action called with row:', row);
//   // console.log('type:', type);
//   dispatch({ type: DELETE_MATERIAL_DESIGN_START });

//   // Show loading overlay
//   dispatch({ type: FETCH_START });

//   // For supplier type, row is an array of view IDs
//   if (type === 'supplier') {
//     return deleteSupplierMaterialDesignAPI(row)
//       .then((res) => {
//         // console.log('deleteMaterialDesign res:', res);
//         dispatch({ type: DELETE_MATERIAL_DESIGN_SUCCESS, payload: res.data });
//         dispatch({
//           type: SHOW_MESSAGE,
//           payload: {
//             message: `Successfully deleted ${type} design`,
//             variant: 'success',
//           },
//         });
//         return res;
//       })
//       .catch((error) => {
//         console.error('Error deleting supplier design:', error);
//         dispatch({ type: DELETE_MATERIAL_DESIGN_FAIL });
//         dispatch({
//           type: SHOW_MESSAGE,
//           payload: {
//             message: `Failed to delete ${type} design`,
//             variant: 'error',
//           },
//         });
//         throw error;
//       });
//   } else {
//     // For material type, use the original implementation
//     const headers = {
//       Authorization: secureLocalStorage.getItem('aTk'),
//       'Content-Type': 'application/json'
//     };

//     let allPromises = [];
//     const endpoint = '/mdm/material-master-design';
//     allPromises.push(
//       axios
//         .delete(`${endpoint}/${row.id}`, { headers })
//         .then((res) => {
//           //console.log('deleteMaterialDesign res:', res);

//           dispatch({ type: DELETE_MATERIAL_DESIGN_SUCCESS, payload: res.data });
//           dispatch({
//             type: SHOW_MESSAGE,
//             payload: {
//               message: `Successfully deleted ${type} design`,
//               variant: 'success',
//             },
//           });
//         })
//     );

//     // Wait for all deletions to complete
//     return Promise.all(allPromises);
//   }
// };
export const deleteEmployeeMaterialDesign = (profile) => {
  return (dispatch) => {
    return deleteEmployeeMaterialDesignAPI(profile)
      .then((response) => {
        dispatch({
          type: DELETE_EMPLOYEE_DESIGN_SUCCESS,
          payload: response.data,
        });

        const msgObj = response.data?.message;

        if (msgObj?.message_type === 'success') {
          globalToast.showSuccess(msgObj.message);
        } else if (msgObj?.message_type === 'error') {
          globalToast.showError(msgObj.message || 'Failed to delete employee design');
        } else {
          globalToast.showInfo(msgObj?.message || 'Deleted successfully');
        }
      })
      .catch((error) => {
        dispatch({ type: DELETE_EMPLOYEE_DESIGN_FAIL });

        const errMessage =
          error?.response?.data?.message?.message ||
          error?.response?.data?.message ||
          'Failed to delete employee design';

        globalToast.showError(errMessage);
      });
  };
};

export const deleteEmployeeMaterialDesignAPI = (profile) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
    'Content-Type': 'application/json',
  };
  return axios.delete(`mdm/employee-master-design?profile=${profile}`, {
    headers: headers,
  });
};
export const deleteCustomerMaterialDesign = (profile) => {
  return (dispatch) => {
    return deleteCustomerMaterialDesignAPI(profile)
      .then((response) => {
        dispatch({
          type: DELETE_CUSTOMER_DESIGN_SUCCESS,
          payload: response.data,
        });

        const msgObj = response.data?.message;

        if (msgObj?.message_type === 'success') {
          globalToast.showSuccess(msgObj.message);
        } else if (msgObj?.message_type === 'error') {
          globalToast.showError(msgObj.message || 'Failed to delete customer design');
        } else {
          globalToast.showInfo(msgObj?.message || 'Deleted successfully');
        }
      })
      .catch((error) => {
        dispatch({ type: DELETE_CUSTOMER_DESIGN_FAIL });

        const errMessage =
          error?.response?.data?.message?.message ||
          error?.response?.data?.message ||
          'Failed to delete customer design';

        globalToast.showError(errMessage);
      });
  };
};

export const deleteCustomerMaterialDesignAPI = (profile) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
    'Content-Type': 'application/json',
  };
  return axios.delete(`mdm/customer-master-design?profile=${profile}`, {
    headers: headers,
  });
};
export const deleteProductMaterialDesign = (profile) => {
  return (dispatch) => {
    return deleteProductMaterialDesignAPI(profile)
      .then((response) => {
        dispatch({
          type: DELETE_PRODUCT_MATERIAL_DESIGN_SUCCESS,
          payload: response.data,
        });

        const msgObj = response.data?.message;

        if (msgObj?.message_type === 'success') {
          globalToast.showSuccess(msgObj.message);
        } else if (msgObj?.message_type === 'error') {
          globalToast.showError(msgObj.message || 'Failed to delete material design');
        } else {
          globalToast.showInfo(msgObj?.message || 'Deleted successfully');
        }
      })
      .catch((error) => {
        dispatch({ type: DELETE_PRODUCT_MATERIAL_DESIGN_FAIL });

        const errMessage =
          error?.response?.data?.message?.message ||
          error?.response?.data?.message ||
          'Failed to delete material design';

        globalToast.showError(errMessage);
      });
  };
};

export const deleteProductMaterialDesignAPI = (profile) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
    'Content-Type': 'application/json',
  };
  return axios.delete(`mdm/material-master-design?profile=${profile}`, {
    headers: headers,
  });
};
export const deleteSupplierMaterialDesign = (profile) => {
  return (dispatch) => {
    return deleteSupplierMaterialDesignAPI(profile)
      .then((response) => {
        dispatch({
          type: DELETE_SUPPLIER_DESIGN_SUCCESS,
          payload: response.data,
        });

        const msgObj = response.data?.message;

        if (msgObj?.message_type === 'success') {
          globalToast.showSuccess(msgObj.message);
        } else if (msgObj?.message_type === 'error') {
          globalToast.showError(msgObj.message || 'Failed to delete supplier design');
        } else {
          globalToast.showInfo(msgObj?.message || 'Deleted successfully');
        }
      })
      .catch((error) => {
        dispatch({ type: DELETE_SUPPLIER_DESIGN_FAIL });

        // Try to get a meaningful error message
        const errMessage =
          error?.response?.data?.message?.message || // nested message object
          error?.response?.data?.message || // fallback
          'Failed to delete supplier design';

        globalToast.showError(errMessage);
      });
  };
};

export const deleteSupplierMaterialDesignAPI = (profile) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
    'Content-Type': 'application/json',
  };
  return axios.delete(`mdm/supplier-master-design?profile=${profile}`, {
    headers: headers,
  });
};
export const cloneMaterialDesign = (id) => {
  return (dispatch) => {
    return viewMaterialDesignAPI(id)
      .then((response) => {
        const originalData = response.data.response;

        // Create a clone of the data with modified values
        const clonedData = {
          material_category: `${originalData.material_category}_Clone`,
          description: `${originalData.description} (Clone)`,
          profile: originalData.profile,
          view: originalData.view,
          attributes: originalData.attributes.map((attr) => ({
            attribute: attr.attribute,
            attribute_names: attr.attribute_names,
            view_category: attr.view_category,
            multiple_rows: attr.multiple_rows,
          })),
        };

        // Send the cloned data to the API
        return addMaterialDesignAPI(clonedData).then((cloneResponse) => {
          // Refresh the material design list
          dispatch(getMasterDataProfile());
          return cloneResponse;
        });
      })
      .catch((error) => {
        console.error('Error cloning material design:', error);
        throw error;
      });
  };
};
export const getEmployeeByProfile = (profile) => {
  return (dispatch) => {
    return getEmployeeByProfileAPI(profile)
      .then((response) => {
        //console.log('getEmployeeByProfile response:', response.data);
        dispatch(getEmployeeByProfileSuccess(response.data.response));
        return response.data.response;
      })
      .catch((error) => {
        console.error('Error getting employee by profile:', error);
        throw error;
      });
  };
};

const getEmployeeByProfileAPI = (profile) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  return axios.get(`mdm/employee-master-design?profile=${profile}`, {
    headers,
  });
};

export const getEmployeeByProfileSuccess = (data) => {
  return {
    type: GET_EMPLOYEE_BY_PROFILE_SUCCESS,
    data,
  };
};
export const cloneMaterialMaster = (data) => {
  return (dispatch) => {
    return cloneMaterialMasterAPI(data)
      .then((response) => {
        dispatch(cloneMaterialMasterSuccess(response.data.response));

        const messageArray = response.data?.message;
        if (Array.isArray(messageArray)) {
          messageArray.forEach((msgObj) => {
            if (msgObj.message_type === 'success') {
              globalToast.showSuccess(msgObj.message);
            } else if (msgObj.message_type === 'error') {
              globalToast.showError(msgObj.message);
            } else if (msgObj.message_type === 'warning') {
              globalToast.showWarning(msgObj.message);
            } else {
              globalToast.showInfo(msgObj.message);
            }
          });
        }

        return response.data.response;
      })
      .catch((error) => {
        console.error('Error cloning material master:', error);

        const errMessage =
          error?.response?.data?.message?.message ||
          error?.response?.data?.message ||
          'Failed to clone material profile';

        globalToast.showError(errMessage);
        throw error;
      });
  };
};

export const cloneMaterialMasterSuccess = (data) => {
  return {
    type: CLONE_MATERIAL_MASTER_SUCCESS,
    data,
  };
};

const cloneMaterialMasterAPI = (data) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };

  return axios.post(`mdm/material-master-design/copy-profile`, data, {
    headers,
  });
};
export const cloneEmployeeMaster = (data) => {
  return (dispatch) => {
    return cloneEmployeeMasterAPI(data)
      .then((response) => {
        dispatch(cloneEmployeeMasterSuccess(response.data.response));

        const messageArray = response.data?.message;
        if (Array.isArray(messageArray)) {
          messageArray.forEach((msgObj) => {
            if (msgObj.message_type === 'success') {
              globalToast.showSuccess(msgObj.message);
            } else if (msgObj.message_type === 'error') {
              globalToast.showError(msgObj.message);
            } else if (msgObj.message_type === 'warning') {
              globalToast.showWarning(msgObj.message);
            } else {
              globalToast.showInfo(msgObj.message);
            }
          });
        }

        return response.data.response;
      })
      .catch((error) => {
        console.error('Error cloning employee master:', error);

        const errMessage =
          error?.response?.data?.message?.message ||
          error?.response?.data?.message ||
          'Failed to clone employee profile';

        globalToast.showError(errMessage);
        throw error;
      });
  };
};

export const cloneEmployeeMasterSuccess = (data) => {
  return {
    type: CLONE_EMPLOYEE_MASTER_SUCCESS,
    data,
  };
};

const cloneEmployeeMasterAPI = (data) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };

  return axios.post(`mdm/employee-master-design/copy-profile`, data, {
    headers,
  });
};
export const cloneSupplierMaster = (data) => {
  return (dispatch) => {
    return cloneSupplierMasterAPI(data)
      .then((response) => {
        dispatch(cloneSupplierMasterSuccess(response.data.response));
        //console.log("cloneSupplierMaster response:", response.data.response);

        const messageArray = response.data?.message;
        if (Array.isArray(messageArray)) {
          messageArray.forEach((msgObj) => {
            if (msgObj.message_type === 'success') {
              globalToast.showSuccess(msgObj.message);
            } else if (msgObj.message_type === 'error') {
              globalToast.showError(msgObj.message);
            } else if (msgObj.message_type === 'warning') {
              globalToast.showWarning(msgObj.message);
            } else {
              globalToast.showInfo(msgObj.message);
            }
          });
        }

        return response.data.response;
      })
      .catch((error) => {
        console.error('Error cloning supplier master:', error);

        const errMessage =
          error?.response?.data?.message?.message || // nested object format
          error?.response?.data?.message || // flat message
          'Failed to clone supplier profile';

        globalToast.showError(errMessage);
        throw error;
      });
  };
};
export const cloneSupplierMasterSuccess = (data) => {
  return {
    type: CLONE_SUPPLIER_MASTER_SUCCESS,
    data,
  };
};
const cloneSupplierMasterAPI = (data) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };

  return axios.post(`mdm/supplier-master-design/copy-profile`, data, {
    headers: headers,
  });
};
export const setCustomerProfileDefault = (profile, callback) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };

  return (dispatch) => {
    return axios
      .put('mdm/customer-master-design', profile, { headers })

      .then((response) => {
        if (response.data && response.data.status === 400) {
          if (response.data.message) {
            globalToast.showError(response.data.message);
          } else {
            globalToast.showError('Failed to set profile as default. Please try again.');
          }

          dispatch(setCustomerProfileDefaultFail(response.data.response));
          return { success: false, error: response.data.response };
        }

        dispatch(setCustomerProfileDefaultSuccess(response.data.response));

        if (callback) {
          callback();
        }

        return { success: true, response };
      })
      .catch((error) => {
        if (error.response && error.response.data) {
          const responseData = error.response.data;

          if (responseData.message) {
            globalToast.showError(responseData.message);
          }
        }

        globalToast.showError('Failed to set profile as default. Please try again.');
        dispatch(setCustomerProfileDefaultFail(error));
        return { success: false, error };
      });
  };
};
export const setCustomerProfileDefaultSuccess = (data) => ({
  type: SET_CUSTOMER_PROFILE_DEFAULT_SUCCESS,
  data,
});

export const setCustomerProfileDefaultFail = (error) => ({
  type: SET_CUSTOMER_PROFILE_DEFAULT_FAIL,
  error,
});
export const setEmployeeProfileDefault = (profile, callback) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };

  return (dispatch) => {
    return axios
      .put('mdm/employee-master-design', profile, { headers })

      .then((response) => {
        if (response.data && response.data.status === 400) {
          if (response.data.message) {
            globalToast.showError(response.data.message);
          } else {
            globalToast.showError('Failed to set profile as default. Please try again.');
          }

          dispatch(setEmployeeProfileDefaultFail(response.data.response));
          return { success: false, error: response.data.response };
        }

        dispatch(setEmployeeProfileDefaultSuccess(response.data.response));

        if (callback) {
          callback();
        }

        return { success: true, response };
      })
      .catch((error) => {
        if (error.response && error.response.data) {
          const responseData = error.response.data;

          if (responseData.message) {
            globalToast.showError(responseData.message);
          }
        }

        globalToast.showError('Failed to set profile as default. Please try again.');
        dispatch(setEmployeeProfileDefaultFail(error));
        return { success: false, error };
      });
  };
};

export const setEmployeeProfileDefaultSuccess = (data) => ({
  type: SET_EMPLOYEE_PROFILE_DEFAULT_SUCCESS,
  data,
});

export const setEmployeeProfileDefaultFail = (error) => ({
  type: SET_EMPLOYEE_PROFILE_DEFAULT_FAIL,
  error,
});
export const setMaterialProfileDefault = (profile, callback) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };

  return (dispatch) => {
    return axios
      .put('mdm/material-master-design', profile, { headers })
      .then((response) => {
        if (response.data && response.data.status === 400) {
          if (response.data.message) {
            globalToast.showError(response.data.message);
          } else {
            globalToast.showError('Failed to set profile as default. Please try again.');
          }

          dispatch(setMaterialProfileDefaultFail(response.data.response));
          return { success: false, error: response.data.response };
        }

        dispatch(setMaterialProfileDefaultSuccess(response.data.response));

        if (callback) {
          callback();
        }

        return { success: true, response };
      })
      .catch((error) => {
        if (error.response && error.response.data) {
          const responseData = error.response.data;

          if (responseData.message) {
            globalToast.showError(responseData.message);
          }
        }

        globalToast.showError('Failed to set profile as default. Please try again.');
        dispatch(setMaterialProfileDefaultFail(error));
        return { success: false, error };
      });
  };
};

export const setMaterialProfileDefaultSuccess = (data) => ({
  type: SET_MATERIAL_PROFILE_DEFAULT_SUCCESS,
  data,
});

export const setMaterialProfileDefaultFail = (error) => ({
  type: SET_MATERIAL_PROFILE_DEFAULT_FAIL,
  error,
});
export const setSupplierProfileDefault = (profile, callback) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  return (dispatch) => {
    return axios
      .put('mdm/supplier-master-design', profile, { headers: headers })

      .then((response) => {
        // Handle 400 errors that might come with a 200 status
        if (response.data && response.data.status === 400) {
          if (response.data.message) {
          } else {
            globalToast.showError('Failed to set profile as default. Please try again.');
          }

          dispatch(setSupplierProfileDefaultFail(response.data.response));
          return { success: false, error: response.data.response };
        }

        // Handle successful response
        dispatch(setSupplierProfileDefaultSuccess(response.data.response));

        if (callback) {
          callback();
        }

        return { success: true, response };
      })
      .catch((error) => {
        // console.log('API Error:', error);

        // Check for error response with data
        if (error.response && error.response.data) {
          const responseData = error.response.data;

          if (responseData.message) {
            globalToast.showError(responseData.message);
          }
        }

        // Generic error if no specific errors found
        globalToast.showError('Failed to set profile as default. Please try again.');
        dispatch(setSupplierProfileDefaultFail(error));
        return { success: false, error };
      });
  };
};

// global control config get api
export const getControlConfig = (params) => {
  return (dispatch) => {
    dispatch(fetchStart());
    return getControlConfigAPI(params)
      .then((response) => {
        dispatch(fetchEnd());
        dispatch(getControlConfigSuccess(response.data.response));
        return response.data.response;
      })
      .catch((error) => {
        dispatch(fetchEnd());
        throw error;
      });
  };
};

export const getControlConfigSuccess = (data) => {
  return {
    type: GET_CONTROL_CONFIG_SUCCESS,
    data,
  };
};

const getControlConfigAPI = (params) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  return axios.get('/control-config', { params, headers })
};

// global control config CRUD

export const controlConfig = (data) => {
  return async (dispatch) => {
    dispatch(fetchStart());
    try {
      const response = await controlConfigAPi(data);
      dispatch(fetchEnd());
      if (data.operation === 'READ') {
        dispatch(ControlConfigDataSuccess(response.data.response));
        return response.data.response;
      }
      const logNumber = response?.data?.log_number;
      if (logNumber) {
        const { hasError } = await handleExecutionLog(dispatch, logNumber);
        if (!hasError) {
          const locationData = {
            application: data.application_type,
            functionality: data.functionality,
            process: data.process,
            breadcrumTitle: sessionStorage.getItem('breadcrumTitle') || 'Global Configuration',
            refresh: true
          };
          history.push({
            pathname: '/global-configuration',
            state: locationData,
          });
        }
        return { success: !hasError, response };
      } else {
        globalToast.showSuccess(response.data.response);
        const locationData = {
          application: data.application_type,
          functionality: data.functionality,
          process: data.process,
          breadcrumTitle: sessionStorage.getItem('breadcrumTitle') || 'Global Configuration',
          refresh: true
        };
        history.push({
          pathname: '/global-configuration',
          state: locationData,
        });
        return { success: true, response };
      }
    } catch (error) {
      dispatch(fetchEnd());
      if (error?.response?.data?.log_number) return { success: false, response: error.response };
      throw error;
    }
  };
};

const controlConfigAPi = (data) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result = axios.post(
    '/maintain-configuration',
    data,
    { headers: headers },
  );
  return result;
};

export const ControlConfigDataSuccess = (data) => {
  return {
    type: CONTROL_CONFIG_DATA_SUCCESS,
    data,
  };
};

// list assignment for a global list
export const getListAssignment = (listName) => {
  return async (dispatch) => {
    dispatch(fetchStart());
    try {
      const response = await getListAssignmentAPI(listName);
      return response?.data?.response;
    } finally {
      dispatch(fetchEnd());
    }
  };
};

const getListAssignmentAPI = (listName) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  return axios.get(`/list-assignment/${encodeURIComponent(listName)}`, { headers });
};

// rows for a global list
export const getListData = (data) => {
  return async (dispatch) => {
    dispatch(fetchStart());
    try {
      return await getListDataAPI(data);
    } finally {
      dispatch(fetchEnd());
    }
  };
};

const getListDataAPI = (data) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  return axios.post('/list-data', data, { headers });
};



// Supplier Rebate Accrual and Payment
export const supplierRebateAccrualPaymentResults = (data, apiPath, page) => {
  return async (dispatch) => {
    dispatch(fetchStart());
    try {
      const response = await supplierRebateAccrualPaymentResultsAPi(data, apiPath, page);
      dispatch(fetchEnd());
      const logNumber = response?.data?.log_number;
      if (logNumber) {
        const { hasError } = await handleExecutionLog(dispatch, logNumber);
        if (!hasError && response?.data?.result && response.data.result.length > 0) {
          dispatch(supplierRebateAccrualPaymentResultsSuccess(response.data));
          history.push(getRebateResultsPath(page));
        }
        return { success: !hasError, response };
      } else {
        if (response?.data?.result && response.data.result.length > 0) {
          dispatch(supplierRebateAccrualPaymentResultsSuccess(response.data));
          history.push(getRebateResultsPath(page));
        } else {
          globalToast.showWarning('No records found.');
        }
        return { success: true, response };
      }
    } catch (error) {
      dispatch(fetchEnd());
      if (error?.response?.data?.log_number) return { success: false, response: error.response };
      throw error;
    }
  };
};

const supplierRebateAccrualPaymentResultsAPi = (data, apiPath, page) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result = axios.post(
    apiPath, data,
    { headers: headers },
  );
  return result;
};
export const supplierRebateAccrualPaymentResultsSuccess = (data) => {
  return {
    type: SUPPLIER_REBATE_ACCRUAL_POSTING_RESULTS_SUCCESS,
    data,
  };
};

export const postingsResults = (data, apiPath, resultPath) => {
  return async (dispatch) => {
    dispatch(fetchStart());
    try {
      const response = await postingsResultsAPi(data, apiPath);
      dispatch(fetchEnd());
      const logNumber = response?.data?.log_number;
      const rawData = Array.isArray(response?.data?.result) ? response?.data?.result : Array.isArray(response?.data?.response) ? response?.data?.response : [];
      if (logNumber) {
        const { hasError } = await handleExecutionLog(dispatch, logNumber);
        if (!hasError && rawData?.length > 0) {
          dispatch(postingsResultsSuccess(response.data));
          history.push(resultPath);
        }
        return { success: !hasError, response };
      } else {
        if (rawData?.length > 0) {
          dispatch(postingsResultsSuccess(response.data));
          history.push(resultPath);
        } else {
          globalToast.showWarning('No records found.');
        }
        return { success: true, response };
      }
    } catch (error) {
      dispatch(fetchEnd());
      if (error?.response?.data?.log_number) return { success: false, response: error.response };
      throw error;
    }
  };
};

const postingsResultsAPi = (data, apiPath) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  return axios.post(apiPath, data, { headers: headers });
};

export const postingsResultsSuccess = (data) => {
  return {
    type: POSTINGS_RESULTS_SUCCESS,
    data,
  };
};

export const postingsReversal = (payload, reversalType) => {
  return async (dispatch) => {
    dispatch(fetchStart());
    const fullPayload = {
      ...payload,
      application_type: sessionStorage.getItem('application'),
      functionality: reversalType === 'accrual' ? 'Accrual' : 'Payment',
    };
    try {
      const response = await postingsReversalAPi(fullPayload);
      dispatch(fetchEnd());
      const logNumber = response?.data?.log_number;
      if (logNumber) {
        const { hasError } = await handleExecutionLog(dispatch, logNumber);
        return { success: !hasError, response };
      }
      return { success: true, response };
    } catch (error) {
      dispatch(fetchEnd());
      if (error?.response?.data?.log_number) return { success: false, response: error.response };
      throw error;
    }
  };
};

const postingsReversalAPi = (data) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  return axios.post('postings/reversal', data, { headers });
};

// Re-fetch the Posted Accruals grid after a reversal, without navigating —
export const postingsResultsRefresh = (data, apiPath) => {
  return async (dispatch) => {
    dispatch(fetchStart());
    try {
      const response = await postingsResultsAPi(data, apiPath);
      dispatch(fetchEnd());
      const logNumber = response?.data?.log_number;
      if (logNumber) {
        const { hasError } = await handleExecutionLog(dispatch, logNumber);
        if (!hasError && response?.data?.result && response.data.result.length > 0) {
          dispatch(postingsResultsSuccess(response.data));
        }
      } else if (response?.data?.result && response.data.result.length > 0) {
        dispatch(postingsResultsSuccess(response.data));
      } else {
        globalToast.showWarning('No records found.');
      }
    } catch (error) {
      dispatch(fetchEnd());
    }
  };
};

